<script>
import { campaignStatus, listContactInformations } from '@/config/var-common';
import { masterMethods, campaignMethods, clientMethods } from '@/state/helpers';
import { checkPermission } from '@/utils/handlers';
import { keyMaster } from '@/config/constants';
import { InputRadio, InputCheckBox, InputText } from '@/components/Input';
import { formatDateCommon } from '@/utils/format';
import { MODAL_CONFIG } from './components/dowload-data/constants';
import { configHelperCampaign } from './constants';

import Layout from '@/views/layouts/main';
import appConfig from '@/app.config';
import KeyWordTag from '@/components/KeywordTag/main.vue';
import TableListComponent from '@/components/TableList/main.vue';
import ButtonActiveFilter from '@/components/ButtonColFilter/main.vue';
import DownloadDataCampaign from './components/dowload-data/main.vue';
import Multiselect from '@/components/Multiselect/main.vue';
import TextareaComponent from '@/components/Textarea/main.vue';
import inlineEditCampaignMixin from '@/mixins/inlineEditCampaignMixin';
import InlineEditWrapper from '@/views/pages/campaign/components/edit-quick-field/InlineEditWrapper.vue';

export default {
    page: {
        title: 'キャンペーン一覧',
        meta: [{ name: 'description', content: appConfig.description }]
    },
    components: {
        KeyWordTag,
        Layout,
        InputRadio,
        InputCheckBox,
        InputText,
        TableListComponent,
        ButtonActiveFilter,
        DownloadDataCampaign,
        Multiselect,
        TextareaComponent,
        InlineEditWrapper,
        CampaignFilterBasic: () => import('./components/CampaignFilterBasic.vue'),
        CampaignFilterAdvanced: () => import('./components/CampaignFilterAdvanced.vue')
    },
    mixins: [inlineEditCampaignMixin],
    beforeRouteEnter(to, from, next) {
        if (from.name !== 'CampaignView') {
            localStorage.removeItem('BookmarkCampaign');
        }
        if (!checkPermission('campaign.view')) {
            next({ name: 'errorPage' });
        }
        next();
    },
    data() {
        return {
            bookmarkName: '',
            clientObject: null,
            person_in_charge: [],
            responsible_sub_persons: [],
            direction_staff: [],
            scope_partner_inquiry: [],
            scope_partner_application: [],
            scope_partner_shipping: [],
            tool: [],
            scope_partner_secretariat: [],
            sale_staff: [],
            clientPicObject: null,
            project_management: [],
            customer_team_pic: [],
            customer_sub_person: [],
            part_time_employee: [],
            created_by: [],
            configKeywordCampaignEntityId: {
                arrayTag: [],
                placeholder: '',
                removeOnDelete: true
            },
            highSearchs: {
                zac_id: [],
                campaign_entity_id: [],
                sfid: [],
                offical_name_sns: {},
                offical_id_sns: {},
                inform: [],
                url: [],
                information_ip_detail: [],
                tie_up_distribution_name: [],
                tie_up_manufacturer_name: [],
                contact_information_dm: [],
                keywords: [],
                memo: [],
                prize_search: [],
                form_url: [],
                overview_information: [],
                number_of_applications: {},
                initial_quantity: {},
                final_quantity: {},
                increase_quantity: {},
                number_of_inquiries: {},
                social_platforms: {}
            },
            checkShowFilter: false,
            isLoading: true,
            campaignStatus: campaignStatus,
            listContactInformations: listContactInformations,
            listDataBookmark: [],
            listData: [],
            listDataMasterClients: [],
            listClientsSupport: [],
            listDataMasterSaleStaf: [],
            listDataMasterParttime: [],
            listDataMasterInstructorStaf: [],
            listDataMasterCampaignType: [],
            listDataMasterOrderScope: [],
            listAllPartners: [],
            listAllPartnersInquiry: [],
            listAllPartnersApplication: [],
            listAllPartnersSecretariat: [],
            listAllPartnersShipping: [],
            listAllTools: [],
            listDataMasterCampaignAdvertising: [],
            listTypeTitlePrize: [],
            listPurchaseConditions: [],
            listInformationIp: [],
            listSponsorInformation: [],
            listSocialPlatform: [],
            listTargetProduct: [],
            listTagFreeWord: [],
            listTagKeyWord: [],
            filterType: 'basic',
            search: {
                name: [],
                code: [],
                client_order_source: [],
                client_generate_file: [],
                inquiry_office: [],
                phone_setting_contact_information: [],
                contact_information_mail: []
            },
            date_from: configHelperCampaign.getDateFrom(),
            date_to: configHelperCampaign.getDateTo(),
            configTotalWin: {
                isNumber: true,
                isMaxLength: false,
                error: false,
                errorField: '',
                errorCustomMess: '',
                valueSync: '',
                typesValidate: ['max10']
            },
            configTotalInquiry: {
                isNumber: true,
                isMaxLength: false,
                error: false,
                errorField: '',
                errorCustomMess: '',
                valueSync: '',
                typesValidate: ['max10']
            },

            filter: configHelperCampaign.getFilter(),
            has: configHelperCampaign.getHas(),
            checkTodayCampaignStartDate: false,
            checkTodayCampaignEndDate: false,
            checkTodaySecretariatStartDate: false,
            checkTodaySecretariatEndDate: false,
            activeAccordions: {
                overview: true,
                period: false,
                product: false,
                site: false,
                prize: false,
                inquiry: false,
                other: false,
                scope: false,
                customer: false,
                staff: false,
                advertising: false
            },
            paramsQuery: configHelperCampaign.getParamsQuery(),
            numberQuery: configHelperCampaign.getNumberQuery(),
            configKeyword: configHelperCampaign.getConfigKeyword(),
            configKeywordOffice: {
                arrayTag: [],
                placeholder: '',
                removeOnDelete: true
            },
            configKeywordPhoneInformation: {
                arrayTag: [],
                placeholder: '',
                removeOnDelete: true
            },
            configKeywordMailInformation: {
                arrayTag: [],
                placeholder: '',
                removeOnDelete: true
            },
            configKeywordInform: {
                arrayTag: [],
                placeholder: 'キャンペーン告知',
                removeOnDelete: true
            },
            configKeywordInformationIpDetail: {
                arrayTag: [],
                placeholder: 'IPコンテンツ詳細含自由記述',
                removeOnDelete: true
            },
            configKeywordOverviewInformation: {
                arrayTag: [],
                placeholder: '自由記述',
                removeOnDelete: true
            },
            configKeywordTieUpDistributionName: {
                arrayTag: [],
                placeholder: 'タイアップ流通数報詳細',
                removeOnDelete: true
            },
            configKeywordTieUpManufacturerName: {
                arrayTag: [],
                placeholder: 'タイアップメーカー数報詳細',
                removeOnDelete: true
            },
            configKeywordContactInformationDm: {
                arrayTag: [],
                placeholder: 'お問い合わせDM対応アカウント',
                removeOnDelete: true
            },
            configKeywordKeywords: {
                arrayTag: [],
                placeholder: '検索キーワード',
                removeOnDelete: true
            },
            configKeywordMemo: {
                arrayTag: [],
                placeholder: 'メモ欄',
                removeOnDelete: true
            },
            configKeywordCode: {
                arrayTag: [],
                placeholder: '',
                removeOnDelete: true
            },
            configKeywordName: {
                arrayTag: [],
                placeholder: '',
                removeOnDelete: true
            },
            configKeywordOrderSource: {
                arrayTag: [],
                placeholder: '',
                removeOnDelete: true
            },
            configKeywordGenerateFile: {
                arrayTag: [],
                placeholder: '',
                removeOnDelete: true
            },
            configKeywordZacId: {
                arrayTag: [],
                placeholder: '',
                removeOnDelete: true
            },
            configKeywordSfid: {
                arrayTag: [],
                placeholder: '',
                removeOnDelete: true
            },
            configKeywordFormUrl: {
                arrayTag: [],
                placeholder: '',
                removeOnDelete: true
            },
            configKeywordUrl: {
                arrayTag: [],
                placeholder: '',
                removeOnDelete: true
            },
            configKeywordPrizeSearch: {
                arrayTag: [],
                placeholder: '',
                removeOnDelete: true
            },
            configKeywordHashtag: {},
            configKeywordApplicationMethod: {},
            configKeywordOfficalNameSns: {},
            configKeywordOfficalIdSns: {},
            configTable: configHelperCampaign.configTable,

            configPage: configHelperCampaign.getConfigPage(),
            configModalListPrv: configHelperCampaign.getConfigModalListPrv(),
            listProjectManagement: [],
            listEmployee: [],
            listDataCustomerTeamPic: [],

            resizing: false,
            currentColumnIndex: null,
            startX: 0,
            startWidth: 0,
            isActiveFilter: true,
            tableHeight: '500px',
            MODAL_CONFIG
        };
    },
    computed: {
        listFilterScopeInquiry() {
            return this.listDataMasterOrderScope.find((item) => item.value === 'お問い合わせ')?.data || [];
        },
        listFilterScopeApplication() {
            return this.listDataMasterOrderScope.find((item) => item.value === '応募収集')?.data || [];
        },
        listFilterScopeSecretariat() {
            return this.listDataMasterOrderScope.find((item) => item.value === '事務局関連')?.data || [];
        },
        listFilterScopeShipping() {
            return this.listDataMasterOrderScope.find((item) => item.value === '発送')?.data || [];
        },
        listFilterScopeProduction() {
            return this.listDataMasterOrderScope.find((item) => item.value === '制作関連')?.data || [];
        },
        listFilterScopeSns() {
            return this.listDataMasterOrderScope.find((item) => item.value === 'SNSアカウント関連')?.data || [];
        },
        listFilterScopeDepartment() {
            return this.listDataMasterOrderScope.find((item) => item.value === '資料系')?.data || [];
        },
        codeColWidth() {
            return (this.configTable?.headers?.[0]?.sub_headers?.[0]?.width || 100) + 'px';
        }
    },
    watch: {
        clientObject: function (newName) {
            this.has.client = newName?.id ?? '';
        },
        sale_staff: function (newName) {
            this.filter.sale_staff = newName?.map((iteP) => iteP.id).join(',') ?? '';
        },
        person_in_charge: function (newName) {
            this.filter.person_in_charge = newName?.map((iteP) => iteP.id).join(',') ?? '';
        },
        responsible_sub_persons: function (newName) {
            this.filter.responsible_sub_persons = newName?.map((iteP) => iteP.id).join(',') ?? '';
        },
        direction_staff: function (newName) {
            this.filter.direction_staff = newName?.map((iteP) => iteP.id).join(',') ?? '';
        },
        created_by: function (newName) {
            this.filter.created_by = newName?.map((iteP) => iteP.id).join(',') ?? '';
        },
        scope_partner_inquiry: function (newName) {
            this.filter.scope_partner_inquiry = newName?.map((iteP) => iteP.id).join(',') ?? '';
        },
        scope_partner_application: function (newName) {
            this.filter.scope_partner_application = newName?.map((iteP) => iteP.id).join(',') ?? '';
        },
        scope_partner_shipping: function (newName) {
            this.filter.scope_partner_shipping = newName?.map((iteP) => iteP.id).join(',') ?? '';
        },
        tool: function (newName) {
            this.filter.tool = newName?.map((iteP) => iteP.id).join(',') ?? '';
        },
        scope_partner_secretariat: function (newName) {
            this.filter.scope_partner_secretariat = newName?.map((iteP) => iteP.id).join(',') ?? '';
        },
        project_management: function (newName) {
            this.filter.project_management = newName?.map((iteP) => iteP.id).join(',') ?? '';
        },
        customer_team_pic: function (newName) {
            this.filter.customer_team_pic = newName?.map((iteP) => iteP.id).join(',') ?? '';
        },
        customer_sub_person: function (newName) {
            this.filter.customer_sub_person = newName?.map((iteP) => iteP.id).join(',') ?? '';
        },
        part_time_employee: function (newName) {
            this.filter.part_time_employee = newName?.map((iteP) => iteP.id).join(',') ?? '';
        },
        clientPicObject: function (newName) {
            this.has.client_pic = newName?.id ?? '';
        },

        'configKeyword.arrayTag': function (newOld) {
            if (!this.checkShowFilter) {
                this.listTagFreeWord = newOld;
            } else {
                this.listTagKeyWord = newOld;
            }
        },
        'configKeywordOffice.arrayTag': function (newOld) {
            this.search.inquiry_office = newOld;
        },
        'configKeywordPhoneInformation.arrayTag': function (newOld) {
            this.search.phone_setting_contact_information = newOld;
        },
        'configKeywordMailInformation.arrayTag': function (newOld) {
            this.search.contact_information_mail = newOld;
        },
        'configKeywordInform.arrayTag': function (newOld) {
            this.highSearchs.inform = newOld;
        },
        'configKeywordInformationIpDetail.arrayTag': function (newOld) {
            this.highSearchs.information_ip_detail = newOld;
        },
        'configKeywordOverviewInformation.arrayTag': function (newOld) {
            this.highSearchs.overview_information = newOld;
        },
        'configKeywordTieUpDistributionName.arrayTag': function (newOld) {
            this.highSearchs.tie_up_distribution_name = newOld;
        },
        'configKeywordTieUpManufacturerName.arrayTag': function (newOld) {
            this.highSearchs.tie_up_manufacturer_name = newOld;
        },
        'configKeywordContactInformationDm.arrayTag': function (newOld) {
            this.highSearchs.contact_information_dm = newOld;
        },
        'configKeywordKeywords.arrayTag': function (newOld) {
            this.highSearchs.keywords = newOld;
        },
        'configKeywordMemo.arrayTag': function (newOld) {
            this.highSearchs.memo = newOld;
        },
        'configKeywordCode.arrayTag': function (newOld) {
            this.search.code = newOld;
        },
        'configKeywordName.arrayTag': function (newOld) {
            this.search.name = newOld;
        },
        'configKeywordOrderSource.arrayTag': function (newOld) {
            this.search.client_order_source = newOld;
        },
        'configKeywordGenerateFile.arrayTag': function (newOld) {
            this.search.client_generate_file = newOld;
        },
        'configKeywordZacId.arrayTag': function (newOld) {
            this.highSearchs.zac_id = newOld;
        },
        'configKeywordCampaignEntityId.arrayTag': function (newOld) {
            this.highSearchs.campaign_entity_id = newOld;
        },
        'configKeywordSfid.arrayTag': function (newOld) {
            this.highSearchs.sfid = newOld;
        },
        'configKeywordFormUrl.arrayTag': function (newOld) {
            this.highSearchs.form_url = newOld;
        },
        'configKeywordUrl.arrayTag': function (newOld) {
            this.highSearchs.url = newOld;
        },
        'configKeywordPrizeSearch.arrayTag': function (newOld) {
            this.highSearchs.prize_search = newOld;
        },
        'filter.campaign_type': function (newVal) {
            if (!this.filter.categories || this.filter.categories.length === 0) return;
            // If master data is not yet loaded, skip clearing to avoid wiping restored bookmark categories
            if (!this.listDataMasterCampaignType || this.listDataMasterCampaignType.length === 0) return;
            if (!newVal) {
                this.filter.categories = [];
                return;
            }

            const validCategoryIds = [];

            const typeData = this.listDataMasterCampaignType.find((t) => t.id === newVal);
            if (typeData && typeData.data) {
                typeData.data.forEach((cat) => validCategoryIds.push(cat.id));
            }

            this.filter.categories = this.filter.categories.filter((catId) => validCategoryIds.includes(catId));
        },
        'filter.prize_type': function (newVal) {
            if (!this.filter.prize_type_detail || this.filter.prize_type_detail.length === 0) return;
            // If master data is not yet loaded, skip clearing to avoid wiping restored bookmark data
            if (!this.listTypeTitlePrize || this.listTypeTitlePrize.length === 0) return;

            const validChildIds = [];

            this.listTypeTitlePrize.forEach((parent) => {
                if (parent.data && newVal.includes(parent.id)) {
                    parent.data.forEach((child) => validChildIds.push(child.id));
                }
            });

            this.filter.prize_type_detail = this.filter.prize_type_detail.filter((id) => validChildIds.includes(id));
        },
        'filter.categories': function (newVal) {
            if (newVal && newVal.length > 0) {
                // Remove data for removed categories
                if (this.highSearchs.offical_name_sns) {
                    Object.keys(this.highSearchs.offical_name_sns).forEach((id) => {
                        if (!newVal.includes(Number(id))) {
                            this.$delete(this.highSearchs.offical_name_sns, id);
                        }
                    });
                }
                if (this.highSearchs.offical_id_sns) {
                    Object.keys(this.highSearchs.offical_id_sns).forEach((id) => {
                        if (!newVal.includes(Number(id))) {
                            this.$delete(this.highSearchs.offical_id_sns, id);
                        }
                    });
                }
                if (this.configKeywordOfficalNameSns) {
                    Object.keys(this.configKeywordOfficalNameSns).forEach((id) => {
                        if (!newVal.includes(Number(id))) {
                            this.$delete(this.configKeywordOfficalNameSns, id);
                        }
                    });
                }
                if (this.configKeywordOfficalIdSns) {
                    Object.keys(this.configKeywordOfficalIdSns).forEach((id) => {
                        if (!newVal.includes(Number(id))) {
                            this.$delete(this.configKeywordOfficalIdSns, id);
                        }
                    });
                }
                if (this.configKeywordApplicationMethod) {
                    Object.keys(this.configKeywordApplicationMethod).forEach((id) => {
                        if (!newVal.includes(Number(id))) {
                            this.$delete(this.configKeywordApplicationMethod, id);
                        }
                    });
                }
                if (this.configKeywordHashtag) {
                    Object.keys(this.configKeywordHashtag).forEach((id) => {
                        if (!newVal.includes(Number(id))) {
                            this.$delete(this.configKeywordHashtag, id);
                        }
                    });
                }
                const numberKeys = ['number_of_applications', 'initial_quantity', 'final_quantity', 'increase_quantity'];
                numberKeys.forEach((key) => {
                    if (this.highSearchs[key]) {
                        Object.keys(this.highSearchs[key]).forEach((id) => {
                            if (!newVal.includes(Number(id))) {
                                this.$delete(this.highSearchs[key], id);
                            }
                        });
                    }
                });

                newVal.forEach((id) => {
                    const label = this.getCategoryLabel(id);
                    if (!this.configKeywordApplicationMethod[id]) {
                        this.$set(this.configKeywordApplicationMethod, id, {
                            arrayTag: [],
                            placeholder: `${label}: 応募方法`,
                            removeOnDelete: true
                        });
                    }
                    if (!this.configKeywordHashtag[id]) {
                        this.$set(this.configKeywordHashtag, id, {
                            arrayTag: [],
                            placeholder: `${label}: ハッシュタグ`,
                            removeOnDelete: true
                        });
                    }
                    if (this.highSearchs.offical_name_sns[id] === undefined) {
                        this.$set(this.highSearchs.offical_name_sns, id, '');
                    }
                    if (this.highSearchs.offical_id_sns[id] === undefined) {
                        this.$set(this.highSearchs.offical_id_sns, id, '');
                    }
                    if (!this.configKeywordOfficalNameSns[id]) {
                        this.$set(this.configKeywordOfficalNameSns, id, {
                            arrayTag: [],
                            placeholder: `${label}: 公認名`,
                            removeOnDelete: true
                        });
                        this.$watch(
                            () => this.configKeywordOfficalNameSns[id].arrayTag,
                            (newVal) => {
                                this.$set(this.highSearchs.offical_name_sns, id, newVal);
                            }
                        );
                    }
                    if (!this.configKeywordOfficalIdSns[id]) {
                        this.$set(this.configKeywordOfficalIdSns, id, {
                            arrayTag: [],
                            placeholder: `${label}: 公認ID`,
                            removeOnDelete: true
                        });
                        this.$watch(
                            () => this.configKeywordOfficalIdSns[id].arrayTag,
                            (newVal) => {
                                this.$set(this.highSearchs.offical_id_sns, id, newVal);
                            }
                        );
                    }
                });

                // Clean up Application Conditions (only when master data is loaded to avoid wiping restored bookmark values)
                if (this.listDataMasterCampaignType && this.listDataMasterCampaignType.length > 0) {
                    let validCondition1Ids = [];
                    this.listDataMasterCampaignType.forEach((type) => {
                        if (type.data) {
                            type.data.forEach((cat) => {
                                if (newVal.includes(cat.id) && cat.data) {
                                    cat.data.forEach((cond) => validCondition1Ids.push(cond.id));
                                }
                            });
                        }
                    });
                    const updatedCond1 = {};
                    const updatedCond2 = {};
                    Object.entries(this.filter.application_condition_1).forEach(([catId, ids]) => {
                        if (newVal.includes(Number(catId))) {
                            updatedCond1[catId] = ids.filter((id) => validCondition1Ids.includes(id));
                        }
                    });
                    Object.entries(this.filter.application_condition_2).forEach(([catId, ids]) => {
                        if (newVal.includes(Number(catId))) {
                            updatedCond2[catId] = ids; // Further cleanup in cond1 watcher
                        }
                    });
                    this.filter.application_condition_1 = updatedCond1;
                    this.filter.application_condition_2 = updatedCond2;
                }
            } else {
                this.filter.application_condition_1 = {};
                this.filter.application_condition_2 = {};
                // Clear all category related data if no category selected
                this.highSearchs.offical_name_sns = {};
                this.highSearchs.offical_id_sns = {};
                this.configKeywordApplicationMethod = {};
                this.configKeywordOfficalNameSns = {};
                this.configKeywordOfficalIdSns = {};
                this.configKeywordHashtag = {};
                this.highSearchs.number_of_applications = {};
                this.highSearchs.initial_quantity = {};
                this.highSearchs.final_quantity = {};
                this.highSearchs.increase_quantity = {};
            }
        },
        'filter.application_condition_1': function (newVal) {
            if (!newVal || Object.keys(newVal).length === 0) {
                this.filter.application_condition_2 = {};
            } else {
                // Only clean up when master data is loaded to avoid wiping restored bookmark values
                if (!this.listDataMasterCampaignType || this.listDataMasterCampaignType.length === 0) return;
                let validCondition2IdsByCat = {};
                const allSelectedCond1Ids = Object.values(newVal).flat();
                this.listDataMasterCampaignType.forEach((type) => {
                    if (type.data) {
                        type.data.forEach((cat) => {
                            if (cat.data) {
                                let validInThisCat = [];
                                cat.data.forEach((cond1) => {
                                    if (allSelectedCond1Ids.includes(cond1.id) && cond1.data) {
                                        cond1.data.forEach((cond2) => validInThisCat.push(cond2.id));
                                    }
                                });
                                validCondition2IdsByCat[cat.id] = validInThisCat;
                            }
                        });
                    }
                });

                const updatedCond2 = {};
                Object.entries(this.filter.application_condition_2).forEach(([catId, ids]) => {
                    const validIdsForCat = validCondition2IdsByCat[catId] || [];
                    updatedCond2[catId] = ids.filter((id) => validIdsForCat.includes(id));
                });
                this.filter.application_condition_2 = updatedCond2;
            }
        },
        'filter.target_product_list_1': function (newVal) {
            if (!this.listTargetProduct || this.listTargetProduct.length === 0) return;
            this.listTargetProduct.forEach((parent) => {
                if (!newVal.includes(parent.id)) {
                    if (parent.data && parent.data.length > 0) {
                        const childIds = parent.data.map((c) => c.id);
                        if (this.filter.target_product_list_2 && this.filter.target_product_list_2.length > 0) {
                            this.filter.target_product_list_2 = this.filter.target_product_list_2.filter((id) => !childIds.includes(id));
                        }
                    }
                }
            });
        },
        'filter.information_ip': function (newVal) {
            if (!this.listInformationIp || this.listInformationIp.length === 0) return;
            this.listInformationIp.forEach((parent) => {
                if (!newVal.includes(parent.id)) {
                    if (parent.data && parent.data.length > 0) {
                        const childIds = parent.data.map((c) => c.id);
                        const hasChildSelected = this.filter.information_ip_detail.some((id) => childIds.includes(id));
                        if (hasChildSelected) {
                            this.filter.information_ip_detail = this.filter.information_ip_detail.filter((id) => !childIds.includes(id));
                        }
                    }
                }
            });
        },
        'filter.purchase_conditions': function (newVal) {
            if (!this.listPurchaseConditions || this.listPurchaseConditions.length === 0) return;

            const purchaseConditionsMap = [
                { keyFrom: 'target_product_amount_from', keyTo: 'target_product_amount_to', name: '対象商品(金額)' },
                { keyFrom: 'target_product_quantity_from', keyTo: 'target_product_quantity_to', name: '対象商品(個数)' },
                { keyFrom: 'target_product_total_amount_from', keyTo: 'target_product_total_amount_to', name: '対象商品合計金額' },
                { keyFrom: 'distribution_total_amount_from', keyTo: 'distribution_total_amount_to', name: '流通合計金額' }
            ];

            purchaseConditionsMap.forEach((condition) => {
                const masterItem = this.listPurchaseConditions.find((item) => item.value === condition.name);
                if (masterItem && !newVal.includes(masterItem.id)) {
                    this.date_from[condition.keyFrom] = '';
                    this.date_to[condition.keyTo] = '';
                }
            });
        },
        'filter.social_platform_id': function (newVal) {
            if (!this.highSearchs.social_platforms) return;
            Object.keys(this.highSearchs.social_platforms).forEach((key) => {
                if (!newVal.includes(Number(key)) && !newVal.includes(String(key))) {
                    this.$delete(this.highSearchs.social_platforms, key);
                }
            });
        },
        'filter.sponsor_information': function (newName) {
            if (!newName || !newName.includes(258)) {
                this.date_from.circulation_number_from = '';
                this.date_to.circulation_number_to = '';
                this.date_from.up_manufacturers_from = '';
                this.date_to.up_manufacturers_to = '';
            }
        },
        'filter.order_scope_large': function (newVal) {
            if (!this.listDataMasterOrderScope || this.listDataMasterOrderScope.length === 0) return;

            const selectedLabels = this.listDataMasterOrderScope.filter((item) => newVal.includes(item.id)).map((item) => item.value);

            if (!selectedLabels.includes('資料系')) {
                this.filter.order_scope_department = [];
            }
            if (!selectedLabels.includes('お問い合わせ')) {
                this.filter.order_scope_inquiry = [];
                this.filter.order_scope_inquiry_detail = [];
            }
        }
    },
    async mounted() {
        this.getWidthTableStorage();
        await this.getListMasterCampaignType();
        await this.handleGetMasterOrderScope();
        await this.handleGetAllTools();
        await this.handleGetAllPartners();
        await this.getListBookmark();
        await this.getListCommonUser();
        await this.getListMasterCommon();
        await this.getListMasterClients();
        await this.handleOnMoundedGetList();
        document.addEventListener('keydown', this.handleGlobalEnter);
    },
    beforeDestroy() {
        document.removeEventListener('keydown', this.handleGlobalEnter);
    },

    methods: {
        getCategoryLabel(id) {
            if (!this.listDataMasterCampaignType) return '';
            for (const type of this.listDataMasterCampaignType) {
                if (type.data) {
                    const found = type.data.find((c) => c.id === id);
                    if (found) return `${found.value}(${type.value})`;
                }
            }
            return '';
        },
        checkPermission,
        ...masterMethods,
        ...campaignMethods,
        ...clientMethods,
        onCheckToday(check, typeDate) {
            // Update the state variable manually since we are using event instead of v-model
            if (typeDate === 'campaign_start_date') this.checkTodayCampaignStartDate = check;
            if (typeDate === 'campaign_end_date') this.checkTodayCampaignEndDate = check;
            if (typeDate === 'secretariat_start_date') this.checkTodaySecretariatStartDate = check;
            if (typeDate === 'secretariat_end_date') this.checkTodaySecretariatEndDate = check;

            if (check) {
                switch (typeDate) {
                    case 'campaign_start_date':
                        this.date_from.campaign_start_date = '';
                        this.date_to.campaign_start_date = '';
                        break;
                    case 'campaign_end_date':
                        this.date_from.campaign_end_date = '';
                        this.date_to.campaign_end_date = '';
                        break;
                    case 'secretariat_start_date':
                        this.date_from.secretariat_start_date = '';
                        this.date_to.secretariat_start_date = '';
                        break;
                    case 'secretariat_end_date':
                        this.date_from.secretariat_end_date = '';
                        this.date_to.secretariat_end_date = '';
                        break;
                }
                this.addBookMarkLocalStorage();
                this.getList();
            } else {
                // If unchecked, maybe just refresh list with dates enabled
                this.getList();
            }
        },
        handleChangeFilterInquiry(item) {
            this.filter.order_scope_inquiry_detail = this.filter.order_scope_inquiry_detail.filter((detail) => {
                return !item.data.some((dataItem) => dataItem.id === detail.id);
            });
        },
        handleChangeFilterApplication(item) {
            this.filter.order_scope_application_detail = this.filter.order_scope_application_detail.filter((detail) => {
                return !item.data.some((dataItem) => dataItem.id === detail.id);
            });
        },
        handleChangeFilterSecretariat(item) {
            const level2Ids = item.data.map((d) => d.id);
            const level3Ids = item.data.flatMap((d) => (d.data ? d.data.map((sub) => sub.id) : []));
            const idsToRemove = [...level2Ids, ...level3Ids];
            this.filter.order_scope_secretariat_detail = this.filter.order_scope_secretariat_detail.filter((detail) => {
                return !idsToRemove.includes(detail.id);
            });
        },
        handleChangeFilterSecretariatDetail(item) {
            const idsToRemove = item.data ? item.data.map((sub) => sub.id) : [];
            this.filter.order_scope_secretariat_detail = this.filter.order_scope_secretariat_detail.filter((detail) => {
                return !idsToRemove.includes(detail.id);
            });
        },
        handleChangeFilterShipping(item) {
            this.filter.order_scope_shipping_detail = this.filter.order_scope_shipping_detail.filter((detail) => {
                return !item.data.some((dataItem) => dataItem.id === detail.id);
            });
        },
        handleChangeFilterProduction(item) {
            this.filter.order_scope_production_detail = this.filter.order_scope_production_detail.filter((detail) => {
                return !item.data.some((dataItem) => dataItem.id === detail.id);
            });
        },
        handleChangeFilterSns(item) {
            this.filter.order_scope_sns_account_detail = this.filter.order_scope_sns_account_detail.filter((detail) => {
                return !item.data.some((dataItem) => dataItem.id === detail.id);
            });
        },
        async getListCommonUser() {
            try {
                const dataRes = await this.listMaster('campaign/common-user');
                this.listProjectManagement = this.listDataMasterInstructorStaf = dataRes['admin_and_instructor']; //1,3
                this.listEmployee = dataRes['employees'];
                this.listDataCustomerTeamPic = dataRes['customer_team'];
                this.listDataMasterSaleStaf = dataRes['sale']; //2;
                this.listDataMasterParttime = dataRes['parttime'];
            } catch (error) {
                console.log('error', error);
            }
        },
        async getListMasterCommon() {
            try {
                const dataRes = await this.listMaster('campaign/common-campaign-data');
                this.listTypeTitlePrize = dataRes['event_prize.type'];
                this.listPurchaseConditions = dataRes['campaign.purchase_condition'];
                this.listTargetProduct = dataRes['campaign.product_target'];
                this.listInformationIp = dataRes['campaign.information_ip'];
                this.listSponsorInformation = dataRes['campaign.sponsor_information'];
                this.listSocialPlatform = dataRes['campaign.social_platform'];
            } catch (error) {
                console.log('error', error);
            }
        },

        handleShowFilter() {
            this.checkShowFilter = !this.checkShowFilter;
        },
        getListMasterCampaignType() {
            this.listMaster(keyMaster['campaign.type']).then((data) => {
                this.listDataMasterCampaignType = data;
            });
            this.listMaster(keyMaster['campaign.advertising']).then((data) => {
                this.listDataMasterCampaignAdvertising = data;
            });
        },
        async handleGetMasterOrderScope() {
            try {
                const resultMasterOrder = await this.getMasterOrderScope();
                if (resultMasterOrder.code !== 200) return;
                this.listDataMasterOrderScope = resultMasterOrder.data;
            } catch (error) {
                console.log(error);
            }
        },
        async handleGetAllPartners() {
            try {
                const result = await this.getAllPartners('');
                if (result.code !== 200) return;
                this.listAllPartners = result.data;
                const resultInquiry = await this.getAllPartners('has[large_item]=1');
                this.listAllPartnersInquiry = resultInquiry.data;
                const resultApplication = await this.getAllPartners('has[large_item]=14');
                this.listAllPartnersApplication = resultApplication.data;
                const resultSecretariat = await this.getAllPartners('has[large_item]=28');
                this.listAllPartnersSecretariat = resultSecretariat.data;
                const resultShipping = await this.getAllPartners('has[large_item]=82');
                this.listAllPartnersShipping = resultShipping.data;
            } catch (error) {
                console.log(error);
            }
        },
        async handleGetAllTools() {
            try {
                const result = await this.getAllTools('filters[large_item]=14,28');
                if (result.code !== 200) return;
                this.listAllTools = result.data;
            } catch (error) {
                console.log(error);
            }
        },
        getListBookmark() {
            this.getBookmark('filter[page]=campaign').then((data) => {
                if (data.code == 200) {
                    this.listDataBookmark = data.data;
                }
            });
        },
        getListMasterClients() {
            this.listMaster('all/clients').then((data) => {
                this.listDataMasterClients = data;
            });
        },
        getListMasterClientsSupport() {
            this.listClientsSupport = [];
            this.clientPicObject = null;
            if (this.clientObject?.id) {
                this.listClientSupport({ id: this.clientObject.id, query: 'limit=999' }).then((data) => {
                    this.listClientsSupport = data.data;
                    this.loading = false;
                });
            }
        },

        goToEdit(path, item) {
            this.$router.push({ path: path, query: { id: item.id } });
        },
        getQueryString() {
            let query = [`page=${this.configPage.page}`, `limit=${this.configPage.limit}`, `sorts[id]=desc`];

            if (this.has) {
                for (const [key, value] of Object.entries(this.has)) {
                    if (key && value) query.push(`has[${key}]=${value}`);
                }
            }

            if (this.checkShowFilter) {
                if (this.search) {
                    for (const [key, value] of Object.entries(this.search)) {
                        if (key && value) query.push(`search[${key}]=${decodeURIComponent(value)}`);
                    }
                }

                if (this.filter) {
                    let filter = Object.assign({}, this.filter);

                    if (this.filterType === 'advanced') {
                        if (filter.is_before_due_date.length > 0 || filter.is_post_effective_date.length > 0) {
                            if (filter.is_before_due_date) {
                                let val = filter.is_before_due_date.includes('1') ? 1 : 0;
                                query.push(`filters[is_before_due_date]=${val}`);
                                delete filter.is_before_due_date;
                            }
                            if (filter.is_post_effective_date) {
                                let val = filter.is_post_effective_date.includes('1') ? 1 : 0;
                                query.push(`filters[is_post_effective_date]=${val}`);
                                delete filter.is_post_effective_date;
                            }
                        }
                        if (filter.year_end_holiday && filter.year_end_holiday.length > 0) {
                            query.push(`filters[year_end_holiday]=${filter.year_end_holiday.join(',')}`);
                            delete filter.year_end_holiday;
                        }
                        if (filter.give_away_related && filter.give_away_related.length > 0) {
                            query.push(`filters[give_away_related]=${filter.give_away_related.join(',')}`);
                            delete filter.give_away_related;
                        }
                    }

                    let filterOrderScopeInquiry = filter.order_scope_inquiry.filter((item) => {
                        return !filter.order_scope_inquiry_detail.some((detail) => detail.parent_id === item.id);
                    });
                    filter.order_scope_inquiry = [...filterOrderScopeInquiry, ...filter.order_scope_inquiry_detail].map((iteP) => iteP.id).join(',');
                    delete filter.order_scope_inquiry_detail;

                    let filterOrderScopeApplication = filter.order_scope_application.filter((item) => {
                        return !filter.order_scope_application_detail.some((detail) => detail.parent_id === item.id);
                    });
                    filter.order_scope_application = [...filterOrderScopeApplication, ...filter.order_scope_application_detail]
                        .map((iteP) => iteP.id)
                        .join(',');
                    delete filter.order_scope_application_detail;

                    let allSecretariat = [...filter.order_scope_secretariat, ...filter.order_scope_secretariat_detail];
                    let leafSecretariat = allSecretariat.filter((parent) => !allSecretariat.some((child) => child.parent_id === parent.id));
                    filter.order_scope_secretariat = leafSecretariat.map((iteP) => iteP.id).join(',');
                    delete filter.order_scope_secretariat_detail;

                    let filterOrderScopeShipping = filter.order_scope_shipping.filter((item) => {
                        return !filter.order_scope_shipping_detail.some((detail) => detail.parent_id === item.id);
                    });
                    filter.order_scope_shipping = [...filterOrderScopeShipping, ...filter.order_scope_shipping_detail]
                        .map((iteP) => iteP.id)
                        .join(',');
                    delete filter.order_scope_shipping_detail;

                    let filterOrderScopeProduction = filter.order_scope_production.filter((item) => {
                        return !filter.order_scope_production_detail.some((detail) => detail.parent_id === item.id);
                    });
                    filter.order_scope_production = [...filterOrderScopeProduction, ...filter.order_scope_production_detail]
                        .map((iteP) => iteP.id)
                        .join(',');
                    delete filter.order_scope_production_detail;

                    let filterOrderScopeSns = filter.order_scope_sns_account.filter((item) => {
                        return !filter.order_scope_sns_account_detail.some((detail) => detail.parent_id === item.id);
                    });
                    filter.order_scope_sns_account = [...filterOrderScopeSns, ...filter.order_scope_sns_account_detail]
                        .map((iteP) => iteP.id)
                        .join(',');
                    delete filter.order_scope_sns_account_detail;
                    const cond1 = filter.application_condition_1;
                    const cond2 = filter.application_condition_2;
                    delete filter.application_condition_1;
                    delete filter.application_condition_2;
                    delete filter.categories;
                    const targetProd1 = filter.target_product_list_1 ? [...filter.target_product_list_1] : [];
                    const targetProd2 = filter.target_product_list_2 ? [...filter.target_product_list_2] : [];
                    delete filter.target_product_list_1;
                    delete filter.target_product_list_2;
                    const infoIp1 = filter.information_ip ? [...filter.information_ip] : [];
                    const infoIp2 = filter.information_ip_detail ? [...filter.information_ip_detail] : [];
                    delete filter.information_ip;
                    delete filter.information_ip_detail;
                    const prizeType1 = filter.prize_type ? [...filter.prize_type] : [];
                    const prizeType2 = filter.prize_type_detail ? [...filter.prize_type_detail] : [];
                    delete filter.prize_type;
                    delete filter.prize_type_detail;
                    for (const [key, value] of Object.entries(filter)) {
                        if (key && (Array.isArray(value) ? value.length > 0 : value)) {
                            query.push(`filters[${key}]=${value}`);
                        }
                    }
                    if (this.filter.categories && this.filter.categories.length > 0) {
                        let i = 0;
                        this.filter.categories.forEach((catId) => {
                            const selectedCond1Ids = cond1[catId] || [];
                            const selectedCond2IdsInCat = cond2[catId] || [];

                            if (selectedCond1Ids.length === 0) {
                                query.push(`filters[platforms_group][${i}][categories]=${catId}`);
                                i++;
                            } else {
                                // Find the category in master data to know children relationships
                                let masterCat = null;
                                this.listDataMasterCampaignType.forEach((type) => {
                                    if (type.data) {
                                        const FoundCat = type.data.find((c) => c.id === catId);
                                        if (FoundCat) masterCat = FoundCat;
                                    }
                                });

                                selectedCond1Ids.forEach((id1) => {
                                    query.push(`filters[platforms_group][${i}][categories]=${catId}`);
                                    query.push(`filters[platforms_group][${i}][application_condition_1]=${id1}`);

                                    if (masterCat && masterCat.data) {
                                        const masterCond1 = masterCat.data.find((c1) => c1.id === id1);
                                        if (masterCond1 && masterCond1.data) {
                                            const childrenOfId1 = masterCond1.data
                                                .map((c2) => c2.id)
                                                .filter((c2Id) => selectedCond2IdsInCat.includes(c2Id));

                                            if (childrenOfId1.length > 0) {
                                                query.push(`filters[platforms_group][${i}][application_condition_2]=${childrenOfId1.join(',')}`);
                                            }
                                        }
                                    }
                                    i++;
                                });
                            }
                        });
                    }
                    if (targetProd1 && targetProd1.length > 0) {
                        let t_i = 0;
                        targetProd1.forEach((prod1Id) => {
                            query.push(`filters[targets_group][${t_i}][target_product_list_1]=${prod1Id}`);

                            if (this.listTargetProduct) {
                                const masterProd1 = this.listTargetProduct.find((p) => p.id === prod1Id);
                                if (masterProd1 && masterProd1.data) {
                                    const childrenOfProd1 = masterProd1.data.map((p2) => p2.id).filter((p2Id) => targetProd2.includes(p2Id));

                                    if (childrenOfProd1.length > 0) {
                                        query.push(`filters[targets_group][${t_i}][target_product_list_2]=${childrenOfProd1.join(',')}`);
                                    }
                                }
                            }
                            t_i++;
                        });
                    }
                    if (infoIp1 && infoIp1.length > 0) {
                        let i_i = 0;
                        infoIp1.forEach((ipId) => {
                            query.push(`filters[information_ip_group][${i_i}][information_ip]=${ipId}`);

                            if (this.listInformationIp) {
                                const masterIp1 = this.listInformationIp.find((p) => p.id === ipId);
                                if (masterIp1 && masterIp1.data) {
                                    const childrenOfIp1 = masterIp1.data.map((p2) => p2.id).filter((p2Id) => infoIp2.includes(p2Id));

                                    if (childrenOfIp1.length > 0) {
                                        query.push(`filters[information_ip_group][${i_i}][information_ip_detail]=${childrenOfIp1.join(',')}`);
                                    }
                                }
                            }
                            i_i++;
                        });
                    }
                    if (prizeType1 && prizeType1.length > 0) {
                        let pt_i = 0;
                        prizeType1.forEach((ptId) => {
                            query.push(`filters[prize_types_group][${pt_i}][prize_type]=${ptId}`);

                            if (this.listTypeTitlePrize) {
                                const masterPt1 = this.listTypeTitlePrize.find((p) => p.id === ptId);
                                if (masterPt1 && masterPt1.data) {
                                    const childrenOfPt1 = masterPt1.data.map((p2) => p2.id).filter((p2Id) => prizeType2.includes(p2Id));

                                    if (childrenOfPt1.length > 0) {
                                        query.push(`filters[prize_types_group][${pt_i}][prize_type_detail]=${childrenOfPt1.join(',')}`);
                                    }
                                }
                            }
                            pt_i++;
                        });
                    }
                }
                if (this.highSearchs) {
                    for (const [key, value] of Object.entries(this.highSearchs)) {
                        if (key && value) {
                            if (
                                [
                                    'number_of_applications',
                                    'initial_quantity',
                                    'final_quantity',
                                    'increase_quantity',
                                    'number_of_inquiries',
                                    'social_platforms'
                                ].includes(key)
                            ) {
                                continue;
                            }
                            if (key === 'offical_name_sns' || key === 'offical_id_sns') {
                                let i = 0;
                                for (const [k, v] of Object.entries(value)) {
                                    if (v && this.filter.categories.includes(Number(k))) {
                                        query.push(`highSearchs[${key}][${i}][value]=${v}`);
                                        query.push(`highSearchs[${key}][${i}][where][category_id]=${k}`);
                                        i++;
                                    }
                                }
                            } else {
                                query.push(`highSearchs[${key}]=${value}`);
                            }
                        }
                    }
                }
                if (this.configKeywordHashtag && Object.keys(this.configKeywordHashtag).length > 0) {
                    let i = 0;
                    for (const [key, value] of Object.entries(this.configKeywordHashtag)) {
                        if (value.arrayTag.length > 0 && this.filter.categories.includes(Number(key))) {
                            query.push(`highSearchs[hashtag][${i}][value]=${value.arrayTag.toString()}`);
                            query.push(`highSearchs[hashtag][${i}][where][category_id]=${key}`);
                            i++;
                        }
                    }
                }
                if (this.configKeywordApplicationMethod && Object.keys(this.configKeywordApplicationMethod).length > 0) {
                    let i = 0;
                    for (const [key, value] of Object.entries(this.configKeywordApplicationMethod)) {
                        if (value.arrayTag.length > 0 && this.filter.categories.includes(Number(key))) {
                            query.push(`highSearchs[application_method][${i}][value]=${value.arrayTag.toString()}`);
                            query.push(`highSearchs[application_method][${i}][where][category_id]=${key}`);
                            i++;
                        }
                    }
                }
                if (this.date_from) {
                    let date_from = Object.assign({}, this.date_from);
                    delete date_from.campaign_end_date_m;
                    delete date_from.campaign_end_date_d;
                    delete date_from.campaign_end_date_y;
                    delete date_from.campaign_start_date_y;
                    delete date_from.campaign_start_date_m;
                    delete date_from.campaign_start_date_d;
                    delete date_from.campaign_start_date_d;
                    delete date_from.quantity_for_event_prize;
                    delete date_from.number_of_win_prize;
                    delete date_from.secretariat_end_date_y;
                    delete date_from.secretariat_end_date_m;
                    delete date_from.secretariat_end_date_d;
                    delete date_from.secretariat_start_date_y;
                    delete date_from.secretariat_start_date_m;
                    delete date_from.secretariat_start_date_d;
                    delete date_from.receipt_expiration_start_date_y;
                    delete date_from.receipt_expiration_start_date_m;
                    delete date_from.receipt_expiration_start_date_d;
                    delete date_from.receipt_expiration_end_date_y;
                    delete date_from.receipt_expiration_end_date_m;
                    delete date_from.receipt_expiration_end_date_d;
                    delete date_from.url_publish_time_from_y;
                    delete date_from.url_publish_time_from_m;
                    delete date_from.url_publish_time_from_d;
                    delete date_from.url_publish_time_to_y;
                    delete date_from.url_publish_time_to_m;
                    delete date_from.url_publish_time_to_d;
                    delete date_from.prize_shipping_period_y;
                    delete date_from.prize_shipping_period_m;
                    delete date_from.prize_shipping_period_d;
                    delete date_from.campaign_create_date_y;
                    delete date_from.campaign_create_date_m;
                    delete date_from.campaign_create_date_d;
                    delete date_from.target_product_amount_from;
                    delete date_from.target_product_quantity_from;
                    delete date_from.target_product_total_amount_from;
                    delete date_from.distribution_total_amount_from;
                    date_from.campaign_start_date_time = [date_from.campaign_start_date_time, date_from.campaign_start_date_time_full_time]
                        .filter(Boolean)
                        .join(' ');
                    delete date_from.campaign_start_date_time_y;
                    delete date_from.campaign_start_date_time_m;
                    delete date_from.campaign_start_date_time_d;
                    delete date_from.campaign_start_date_time_full_time;
                    date_from.campaign_end_date_time = [date_from.campaign_end_date_time, date_from.campaign_end_date_time_full_time]
                        .filter(Boolean)
                        .join(' ');
                    delete date_from.campaign_end_date_time_y;
                    delete date_from.campaign_end_date_time_m;
                    delete date_from.campaign_end_date_time_d;
                    delete date_from.campaign_end_date_time_full_time;
                    date_from.secretariat_start_date_time = [date_from.secretariat_start_date_time, date_from.secretariat_start_date_time_full_time]
                        .filter(Boolean)
                        .join(' ');
                    delete date_from.secretariat_start_date_time_y;
                    delete date_from.secretariat_start_date_time_m;
                    delete date_from.secretariat_start_date_time_d;
                    delete date_from.secretariat_start_date_time_full_time;
                    date_from.secretariat_end_date_time = [date_from.secretariat_end_date_time, date_from.secretariat_end_date_time_full_time]
                        .filter(Boolean)
                        .join(' ');
                    delete date_from.secretariat_end_date_time_y;
                    delete date_from.secretariat_end_date_time_m;
                    delete date_from.secretariat_end_date_time_d;
                    delete date_from.secretariat_end_date_time_full_time;
                    for (const [key, value] of Object.entries(date_from)) {
                        if (key && value) {
                            let val = value;
                            if (typeof val === 'string') {
                                val = val.replace(/-+$/, '');
                            }
                            query.push(`from[${key}]=${val}`);
                        }
                    }
                    if (this.date_from.quantity_for_event_prize) {
                        query.push(`range[quantity_for_event_prize][min]=${this.date_from.quantity_for_event_prize}`);
                    }
                    if (this.date_from.number_of_win_prize) {
                        query.push(`range[number_of_win_prize][min]=${this.date_from.number_of_win_prize}`);
                    }
                }
                if (this.date_to) {
                    let date_to = Object.assign({}, this.date_to);
                    delete date_to.campaign_end_date_m;
                    delete date_to.campaign_end_date_d;
                    delete date_to.campaign_end_date_y;
                    delete date_to.campaign_start_date_y;
                    delete date_to.quantity_for_event_prize;
                    delete date_to.number_of_win_prize;
                    delete date_to.campaign_start_date_m;
                    delete date_to.campaign_start_date_m;
                    delete date_to.campaign_start_date_d;
                    delete date_to.secretariat_end_date_y;
                    delete date_to.secretariat_end_date_m;
                    delete date_to.secretariat_end_date_d;
                    delete date_to.secretariat_start_date_y;
                    delete date_to.secretariat_start_date_m;
                    delete date_to.secretariat_start_date_d;
                    delete date_to.receipt_expiration_start_date_y;
                    delete date_to.receipt_expiration_start_date_m;
                    delete date_to.receipt_expiration_start_date_d;
                    delete date_to.receipt_expiration_end_date_y;
                    delete date_to.receipt_expiration_end_date_m;
                    delete date_to.receipt_expiration_end_date_d;
                    delete date_to.circulation_number_from;
                    delete date_to.up_manufacturers_from;
                    delete date_to.url_publish_time_from_y;
                    delete date_to.url_publish_time_from_m;
                    delete date_to.url_publish_time_from_d;
                    delete date_to.url_publish_time_to_y;
                    delete date_to.url_publish_time_to_m;
                    delete date_to.url_publish_time_to_d;
                    delete date_to.prize_shipping_period_y;
                    delete date_to.prize_shipping_period_m;
                    delete date_to.prize_shipping_period_d;
                    delete date_to.campaign_create_date_y;
                    delete date_to.campaign_create_date_m;
                    delete date_to.campaign_create_date_d;
                    delete date_to.target_product_amount_to;
                    delete date_to.target_product_quantity_to;
                    delete date_to.target_product_total_amount_to;
                    delete date_to.distribution_total_amount_to;
                    delete date_to.circulation_number_to;
                    delete date_to.up_manufacturers_to;
                    date_to.campaign_start_date_time = [date_to.campaign_start_date_time, date_to.campaign_start_date_time_full_time]
                        .filter(Boolean)
                        .join(' ');
                    delete date_to.campaign_start_date_time_y;
                    delete date_to.campaign_start_date_time_m;
                    delete date_to.campaign_start_date_time_d;
                    delete date_to.campaign_start_date_time_full_time;
                    date_to.campaign_end_date_time = [date_to.campaign_end_date_time, date_to.campaign_end_date_time_full_time]
                        .filter(Boolean)
                        .join(' ');
                    delete date_to.campaign_end_date_time_y;
                    delete date_to.campaign_end_date_time_m;
                    delete date_to.campaign_end_date_time_d;
                    delete date_to.campaign_end_date_time_full_time;
                    date_to.secretariat_start_date_time = [date_to.secretariat_start_date_time, date_to.secretariat_start_date_time_full_time]
                        .filter(Boolean)
                        .join(' ');
                    delete date_to.secretariat_start_date_time_y;
                    delete date_to.secretariat_start_date_time_m;
                    delete date_to.secretariat_start_date_time_d;
                    delete date_to.secretariat_start_date_time_full_time;
                    date_to.secretariat_end_date_time = [date_to.secretariat_end_date_time, date_to.secretariat_end_date_time_full_time]
                        .filter(Boolean)
                        .join(' ');
                    delete date_to.secretariat_end_date_time_y;
                    delete date_to.secretariat_end_date_time_m;
                    delete date_to.secretariat_end_date_time_d;
                    delete date_to.secretariat_end_date_time_full_time;
                    for (const [key, value] of Object.entries(date_to)) {
                        if (key && value) {
                            let val = value;
                            if (typeof val === 'string') {
                                val = val.replace(/-+$/, '');
                            }
                            query.push(`to[${key}]=${val}`);
                        }
                    }
                    if (this.date_to.quantity_for_event_prize) {
                        query.push(`range[quantity_for_event_prize][max]=${this.date_to.quantity_for_event_prize}`);
                    }
                    if (this.date_to.number_of_win_prize) {
                        query.push(`range[number_of_win_prize][max]=${this.date_to.number_of_win_prize}`);
                    }
                }

                if (this.date_from.circulation_number_from) {
                    query.push(`from[circulation_number][value]=${this.date_from.circulation_number_from}`);
                    query.push(`from[circulation_number][where][master_id]=258`);
                }
                if (this.date_to.circulation_number_to) {
                    query.push(`to[circulation_number][value]=${this.date_to.circulation_number_to}`);
                    query.push(`to[circulation_number][where][master_id]=258`);
                }

                if (this.date_from.up_manufacturers_from) {
                    query.push(`from[up_manufacturers][value]=${this.date_from.up_manufacturers_from}`);
                    query.push(`from[up_manufacturers][where][master_id]=258`);
                }
                if (this.date_to.up_manufacturers_to) {
                    query.push(`to[up_manufacturers][value]=${this.date_to.up_manufacturers_to}`);
                    query.push(`to[up_manufacturers][where][master_id]=258`);
                }

                if (this.date_to.total_inquiry_to) {
                    query.push(`to[total_inquiry_to]=${this.date_to.total_inquiry_to}`);
                }

                if (this.highSearchs.number_of_applications) {
                    Object.keys(this.highSearchs.number_of_applications).forEach((key, index) => {
                        const item = this.highSearchs.number_of_applications[key];
                        if (item.from) {
                            query.push(`from[number_of_applications][${index}][value]=${item.from}`);
                            query.push(`from[number_of_applications][${index}][where][master_id]=${key}`);
                        }
                        if (item.to) {
                            query.push(`to[number_of_applications][${index}][value]=${item.to}`);
                            query.push(`to[number_of_applications][${index}][where][master_id]=${key}`);
                        }
                    });
                }

                if (this.highSearchs.initial_quantity) {
                    Object.keys(this.highSearchs.initial_quantity).forEach((key, index) => {
                        const item = this.highSearchs.initial_quantity[key];
                        if (item.from) {
                            query.push(`from[initial_quantity][${index}][value]=${item.from}`);
                            query.push(`from[initial_quantity][${index}][where][master_id]=${key}`);
                        }
                        if (item.to) {
                            query.push(`to[initial_quantity][${index}][value]=${item.to}`);
                            query.push(`to[initial_quantity][${index}][where][master_id]=${key}`);
                        }
                    });
                }

                if (this.highSearchs.final_quantity) {
                    Object.keys(this.highSearchs.final_quantity).forEach((key, index) => {
                        const item = this.highSearchs.final_quantity[key];
                        if (item.from) {
                            query.push(`from[final_quantity][${index}][value]=${item.from}`);
                            query.push(`from[final_quantity][${index}][where][master_id]=${key}`);
                        }
                        if (item.to) {
                            query.push(`to[final_quantity][${index}][value]=${item.to}`);
                            query.push(`to[final_quantity][${index}][where][master_id]=${key}`);
                        }
                    });
                }

                if (this.highSearchs.increase_quantity) {
                    Object.keys(this.highSearchs.increase_quantity).forEach((key, index) => {
                        const item = this.highSearchs.increase_quantity[key];
                        if (item.from) {
                            query.push(`from[increase_quantity][${index}][value]=${item.from}`);
                            query.push(`from[increase_quantity][${index}][where][master_id]=${key}`);
                        }
                        if (item.to) {
                            query.push(`to[increase_quantity][${index}][value]=${item.to}`);
                            query.push(`to[increase_quantity][${index}][where][master_id]=${key}`);
                        }
                    });
                }

                if (this.highSearchs.social_platforms) {
                    Object.keys(this.highSearchs.social_platforms).forEach((key, index) => {
                        const item = this.highSearchs.social_platforms[key];
                        if (item.from) {
                            query.push(`from[social_platforms][${index}][value]=${item.from}`);
                            query.push(`from[social_platforms][${index}][where][master_id]=${key}`);
                        }
                        if (item.to) {
                            query.push(`to[social_platforms][${index}][value]=${item.to}`);
                            query.push(`to[social_platforms][${index}][where][master_id]=${key}`);
                        }
                    });
                }

                if (this.highSearchs.number_of_inquiries) {
                    Object.keys(this.highSearchs.number_of_inquiries).forEach((key, index) => {
                        const item = this.highSearchs.number_of_inquiries[key];
                        if (item.from) {
                            query.push(`from[number_of_inquiries][${index}][value]=${item.from}`);
                            query.push(`from[number_of_inquiries][${index}][where][master_order_scope_id]=${key}`);
                        }
                        if (item.to) {
                            query.push(`to[number_of_inquiries][${index}][value]=${item.to}`);
                            query.push(`to[number_of_inquiries][${index}][where][master_order_scope_id]=${key}`);
                        }
                    });
                }

                const purchaseConditionsMap = [
                    { keyFrom: 'target_product_amount_from', keyTo: 'target_product_amount_to', name: '対象商品(金額)' },
                    { keyFrom: 'target_product_quantity_from', keyTo: 'target_product_quantity_to', name: '対象商品(個数)' },
                    { keyFrom: 'target_product_total_amount_from', keyTo: 'target_product_total_amount_to', name: '対象商品合計金額' },
                    { keyFrom: 'distribution_total_amount_from', keyTo: 'distribution_total_amount_to', name: '流通合計金額' }
                ];

                let purchaseConditionIndex = 0;
                purchaseConditionsMap.forEach((condition) => {
                    const fromVal = this.date_from[condition.keyFrom];
                    const toVal = this.date_to[condition.keyTo];

                    if (fromVal || toVal) {
                        const masterItem = this.listPurchaseConditions.find((item) => item.value === condition.name);
                        if (masterItem) {
                            if (fromVal) {
                                query.push(`from[purchase_condition][${purchaseConditionIndex}][value]=${fromVal}`);
                                query.push(`from[purchase_condition][${purchaseConditionIndex}][where][master_id]=${masterItem.id}`);
                            }
                            if (toVal) {
                                query.push(`to[purchase_condition][${purchaseConditionIndex}][value]=${toVal}`);
                                query.push(`to[purchase_condition][${purchaseConditionIndex}][where][master_id]=${masterItem.id}`);
                            }
                            purchaseConditionIndex++;
                        }
                    }
                });
            } else {
                if (this.configKeyword.arrayTag.length > 0) {
                    if (this.filterType === 'advanced') {
                        query.push(`h=${this.configKeyword.arrayTag.toString()}`);
                    } else {
                        query.push(`q=${this.configKeyword.arrayTag.toString()}`);
                    }
                }
            }
            if (this.checkTodayCampaignStartDate) {
                query.push(`filters[is_today_campaign_start_date]=1`);
            }
            if (this.checkTodayCampaignEndDate) {
                query.push(`filters[is_today_campaign_end_date]=1`);
            }
            if (this.checkTodaySecretariatStartDate) {
                query.push(`filters[is_today_secretariat_start_date]=1`);
            }
            if (this.checkTodaySecretariatEndDate) {
                query.push(`filters[is_today_secretariat_end_date]=1`);
            }

            if (this.$route.query) {
                let {
                    is_approved,
                    team_id,
                    sale_staff_team,
                    progress_status,
                    partner_dashboard,
                    person_in_charge_team,
                    person_in_charge_role,
                    client_id,
                    partner_id,
                    sale_or_direction_staff,
                    part_time_employee
                } = this.$route.query;

                this.paramsQuery.is_approved = is_approved ?? '';
                this.paramsQuery.team = team_id ?? '';
                this.paramsQuery.sale_staff_team = sale_staff_team ?? '';
                this.paramsQuery.progress_status = progress_status ?? '';
                this.paramsQuery.partner = partner_dashboard ?? '';
                this.paramsQuery.person_in_charge_team = person_in_charge_team ?? '';
                this.paramsQuery.person_in_charge_role = person_in_charge_role ?? '';
                this.paramsQuery.sale_or_direction_staff = sale_or_direction_staff ?? '';
                this.paramsQuery.part_time_employee = part_time_employee ?? '';
                this.numberQuery.client = client_id ?? '';
                this.numberQuery.partner = partner_id ?? '';

                if (this.numberQuery.client || this.numberQuery.partner) {
                    for (const [key, value] of Object.entries(this.numberQuery)) {
                        if (key && value) {
                            query.push(`has[${key}]=${value}`);
                        }
                    }
                } else {
                    for (const [key, value] of Object.entries(this.paramsQuery)) {
                        if (key && value) {
                            if (
                                ['partner', 'sale_staff_team', 'person_in_charge_team', 'person_in_charge_role', 'part_time_employee'].includes(key)
                            ) {
                                query.push(`has[${key}]=${value}`);
                            } else {
                                query.push(`filters[${key}]=${value}`);
                            }
                        }
                    }
                }
            }

            return query.join('&');
        },
        getList() {
            this.isLoading = true;
            let query = this.getQueryString();
            localStorage.setItem('SearchListCampaign', query);
            this.addBookMarkLocalStorage();
            this.listCampaign(query).then((data) => {
                this.listData = data.data;
                this.configPage.total = data._metadata.total;
                this.configPage.limit = data._metadata.limit * 1;
                this.MODAL_CONFIG.searchId = data._metadata.search_id ?? null;
                if (!this.listData.length && this.configPage.page !== 1) {
                    this.configPage.page = 1;
                    this.getList();
                } else {
                    this.isLoading = false;
                }
            });
        },

        handleSearch() {
            this.getList();
            this.addBookMarkLocalStorage();
            this.$nextTick(() => {
                if (this.$refs.searchResult) {
                    this.$refs.searchResult.scrollIntoView({ behavior: 'smooth' });
                }
            });
        },
        handleOnMoundedGetList() {
            let bookmarkCampaign = localStorage.getItem('BookmarkCampaign');
            if (bookmarkCampaign) {
                this.setBookmark(bookmarkCampaign, 'onMounted');
            } else {
                this.getList();
            }
        },
        setBookmark(queryData, type) {
            let query = JSON.parse(queryData);
            this.checkShowFilter = query.checkShowFilter;
            this.filterType = query.filterType;
            this.configKeyword = query.configKeyword;
            this.configKeywordOffice = query.configKeywordOffice;
            this.configKeywordPhoneInformation = query.configKeywordPhoneInformation;
            this.configKeywordMailInformation = query.configKeywordMailInformation;
            this.configKeywordInform = query.configKeywordInform || {
                arrayTag: [],
                placeholder: 'キャンペーン告知',
                removeOnDelete: true
            };
            this.configKeywordInformationIpDetail = query.configKeywordInformationIpDetail || {
                arrayTag: [],
                placeholder: 'IPコンテンツ詳細含自由記述',
                removeOnDelete: true
            };
            this.configKeywordOverviewInformation = query.configKeywordOverviewInformation || {
                arrayTag: [],
                placeholder: '自由記述',
                removeOnDelete: true
            };
            this.configKeywordTieUpDistributionName = query.configKeywordTieUpDistributionName || {
                arrayTag: [],
                placeholder: 'タイアップ流通数報詳細',
                removeOnDelete: true
            };
            this.configKeywordTieUpManufacturerName = query.configKeywordTieUpManufacturerName || {
                arrayTag: [],
                placeholder: 'タイアップメーカー数報詳細',
                removeOnDelete: true
            };
            this.configKeywordContactInformationDm = query.configKeywordContactInformationDm || {
                arrayTag: [],
                placeholder: 'お問い合わせDM対応アカウント',
                removeOnDelete: true
            };
            this.configKeywordKeywords = query.configKeywordKeywords || {
                arrayTag: [],
                placeholder: '検索キーワード',
                removeOnDelete: true
            };
            this.configKeywordMemo = query.configKeywordMemo || {
                arrayTag: [],
                placeholder: 'メモ欄',
                removeOnDelete: true
            };
            this.configKeywordHashtag = query.configKeywordHashtag || {};
            this.configKeywordApplicationMethod = query.configKeywordApplicationMethod || {};
            this.configKeywordCode = query.configKeywordCode || { arrayTag: [], placeholder: '', removeOnDelete: true };
            this.configKeywordName = query.configKeywordName || { arrayTag: [], placeholder: '', removeOnDelete: true };
            this.configKeywordOrderSource = query.configKeywordOrderSource || { arrayTag: [], placeholder: '', removeOnDelete: true };
            this.configKeywordGenerateFile = query.configKeywordGenerateFile || { arrayTag: [], placeholder: '', removeOnDelete: true };
            this.configKeywordZacId = query.configKeywordZacId || { arrayTag: [], placeholder: '', removeOnDelete: true };
            this.configKeywordCampaignEntityId = query.configKeywordCampaignEntityId || { arrayTag: [], placeholder: '', removeOnDelete: true };
            this.configKeywordSfid = query.configKeywordSfid || { arrayTag: [], placeholder: '', removeOnDelete: true };
            this.configKeywordFormUrl = query.configKeywordFormUrl || { arrayTag: [], placeholder: '', removeOnDelete: true };
            this.configKeywordUrl = query.configKeywordUrl || { arrayTag: [], placeholder: '', removeOnDelete: true };
            this.configKeywordPrizeSearch = query.configKeywordPrizeSearch || { arrayTag: [], placeholder: '', removeOnDelete: true };
            this.configKeywordOfficalNameSns = query.configKeywordOfficalNameSns || {};
            this.configKeywordOfficalIdSns = query.configKeywordOfficalIdSns || {};
            this.activeAccordions = query.activeAccordions || {
                overview: true,
                period: false,
                product: false,
                site: false,
                prize: false,
                inquiry: false,
                other: false,
                scope: false,
                customer: false,
                staff: false,
                advertising: false
            };

            // Re-bind watchers for restored SNS configs
            if (this.configKeywordOfficalNameSns) {
                Object.keys(this.configKeywordOfficalNameSns).forEach((id) => {
                    this.$watch(
                        () => this.configKeywordOfficalNameSns[id].arrayTag,
                        (newVal) => {
                            this.$set(this.highSearchs.offical_name_sns, id, newVal);
                        }
                    );
                });
            }
            if (this.configKeywordOfficalIdSns) {
                Object.keys(this.configKeywordOfficalIdSns).forEach((id) => {
                    this.$watch(
                        () => this.configKeywordOfficalIdSns[id].arrayTag,
                        (newVal) => {
                            this.$set(this.highSearchs.offical_id_sns, id, newVal);
                        }
                    );
                });
            }
            this.date_from = query.date_from;
            this.date_to = query.date_to;
            this.date_to = query.date_to;
            this.filter = query.filter;
            if (!this.filter.client_order_source_type) {
                this.$set(this.filter, 'client_order_source_type', []);
            }
            if (!this.filter.client_generate_file_type) {
                this.$set(this.filter, 'client_generate_file_type', []);
            }
            this.has = {
                ...this.has,
                ...query.has
            };
            this.highSearchs = {
                ...this.highSearchs,
                ...query.highSearchs
            };
            this.project_management =
                query?.filter?.project_management?.length > 0
                    ? this.listProjectManagement.filter((x) => query.filter.project_management.split(',').find((iteP) => iteP == x.id)) ?? []
                    : [];
            this.customer_team_pic =
                query?.filter?.customer_team_pic?.length > 0
                    ? this.listDataCustomerTeamPic.filter((x) => query.filter.customer_team_pic.split(',').find((iteP) => iteP == x.id)) ?? []
                    : [];
            this.customer_sub_person =
                query?.filter?.customer_sub_person?.length > 0
                    ? this.listDataCustomerTeamPic.filter((x) => query.filter.customer_sub_person.split(',').find((iteP) => iteP == x.id)) ?? []
                    : [];
            this.part_time_employee =
                query?.filter?.part_time_employee?.length > 0
                    ? this.listDataMasterParttime.filter((x) => query.filter.part_time_employee.split(',').find((iteP) => iteP == x.id)) ?? []
                    : [];
            this.sale_staff =
                query?.filter?.sale_staff?.length > 0
                    ? this.listDataMasterSaleStaf.filter((x) => query.filter.sale_staff.split(',').find((iteP) => iteP == x.id)) ?? []
                    : [];
            this.person_in_charge =
                query?.filter?.person_in_charge?.length > 0
                    ? this.listDataMasterInstructorStaf.filter((x) => query.filter.person_in_charge.split(',').find((iteP) => iteP == x.id)) ?? []
                    : [];
            this.responsible_sub_persons =
                query?.filter?.responsible_sub_persons?.length > 0
                    ? this.listDataMasterInstructorStaf.filter((x) => query.filter.responsible_sub_persons.split(',').find((iteP) => iteP == x.id)) ??
                      []
                    : [];
            this.direction_staff =
                query?.filter?.direction_staff?.length > 0
                    ? this.listDataMasterInstructorStaf.filter((x) => query.filter.direction_staff.split(',').find((iteP) => iteP == x.id)) ?? []
                    : [];
            this.created_by =
                query?.filter?.created_by?.length > 0
                    ? this.listEmployee.filter((x) => query.filter.created_by.split(',').find((iteP) => iteP == x.id)) ?? []
                    : [];
            this.scope_partner_inquiry =
                query?.filter?.scope_partner_inquiry?.length > 0
                    ? this.listAllPartners.filter((x) => query.filter.scope_partner_inquiry.split(',').find((iteP) => iteP == x.id)) ?? []
                    : [];
            this.scope_partner_application =
                query?.filter?.scope_partner_application?.length > 0
                    ? this.listAllPartners.filter((x) => query.filter.scope_partner_application.split(',').find((iteP) => iteP == x.id)) ?? []
                    : [];
            this.scope_partner_shipping =
                query?.filter?.scope_partner_shipping?.length > 0
                    ? this.listAllPartners.filter((x) => query.filter.scope_partner_shipping.split(',').find((iteP) => iteP == x.id)) ?? []
                    : [];
            this.tool =
                query?.filter?.tool?.length > 0
                    ? this.listAllTools.filter((x) => query.filter.tool.split(',').find((iteP) => iteP == x.id)) ?? []
                    : [];
            this.scope_partner_secretariat =
                query?.filter?.scope_partner_secretariat?.length > 0
                    ? this.listAllPartners.filter((x) => query.filter.scope_partner_secretariat.split(',').find((iteP) => iteP == x.id)) ?? []
                    : [];
            this.clientObject = this.listDataMasterClients.find((x) => x.id === query?.has?.client) ?? null;
            if (this.clientObject?.id) {
                this.listClientSupport({ id: this.clientObject.id, query: 'limit=999' }).then((data) => {
                    this.listClientsSupport = data.data;
                    this.clientPicObject = data.data.find((x) => x.id === query?.has?.client_pic) ?? null;
                });
            }
            this.search = query.search;
            if (query.configPage) {
                this.configPage.page = query.configPage.page;
                this.configPage.limit = query.configPage.limit;
            } else {
                this.configPage.page = 1;
            }
            if (type === 'onMounted') {
                this.checkTodayCampaignStartDate = query.checkTodayCampaignStartDate;
                this.checkTodaySecretariatStartDate = query.checkTodaySecretariatStartDate;
                this.checkTodaySecretariatEndDate = query.checkTodaySecretariatEndDate;
            }
            this.addBookMarkLocalStorage();
            if (type !== 'onMounted') {
                this.isActiveFilter = false;
            }
            this.getList();
        },

        deleteBookmarks(event, item) {
            event.stopPropagation();
            this.deleteBookmark(item.id).then((data) => {
                if (data.code == 200) {
                    this.getListBookmark();
                }
            });
        },
        clear() {
            this.configKeyword.arrayTag = [];
            this.configKeywordOffice = {
                ...this.configKeywordOffice,
                arrayTag: [],
                placeholder: ''
            };
            this.configKeywordPhoneInformation = {
                ...this.configKeywordPhoneInformation,
                arrayTag: [],
                placeholder: ''
            };
            this.configKeywordMailInformation = {
                ...this.configKeywordMailInformation,
                arrayTag: [],
                placeholder: ''
            };
            this.configKeywordInform = {
                ...this.configKeywordInform,
                arrayTag: [],
                placeholder: 'キャンペーン告知'
            };
            this.configKeywordInformationIpDetail = {
                ...this.configKeywordInformationIpDetail,
                arrayTag: [],
                placeholder: 'IPコンテンツ詳細含自由記述'
            };
            this.configKeywordOverviewInformation = {
                ...this.configKeywordOverviewInformation,
                arrayTag: [],
                placeholder: '自由記述'
            };
            this.configKeywordTieUpDistributionName = {
                ...this.configKeywordTieUpDistributionName,
                arrayTag: [],
                placeholder: 'タイアップ流通数報詳細'
            };
            this.configKeywordTieUpManufacturerName = {
                ...this.configKeywordTieUpManufacturerName,
                arrayTag: [],
                placeholder: 'タイアップメーカー数報詳細'
            };
            this.configKeywordContactInformationDm = {
                ...this.configKeywordContactInformationDm,
                arrayTag: [],
                placeholder: 'お問い合わせDM対応アカウント'
            };
            this.configKeywordKeywords = {
                ...this.configKeywordKeywords,
                arrayTag: [],
                placeholder: '検索キーワード'
            };
            this.configKeywordMemo = {
                ...this.configKeywordMemo,
                arrayTag: [],
                placeholder: 'メモ欄'
            };
            this.configKeywordCode.arrayTag = [];
            this.configKeywordName.arrayTag = [];
            this.configKeywordOrderSource.arrayTag = [];
            this.configKeywordGenerateFile.arrayTag = [];
            this.configKeywordZacId.arrayTag = [];
            this.configKeywordSfid.arrayTag = [];
            this.configKeywordFormUrl.arrayTag = [];
            this.configKeywordUrl.arrayTag = [];
            this.configKeywordPrizeSearch.arrayTag = [];
            this.configKeywordHashtag = {};
            this.configKeywordApplicationMethod = {};
            this.configKeywordOfficalNameSns = {};
            this.configKeywordOfficalIdSns = {};
            this.search = {
                name: [],
                code: [],
                client_order_source: [],
                client_generate_file: [],
                inquiry_office: [],
                phone_setting_contact_information: [],
                contact_information_mail: []
            };
            this.filter = {
                code: '',
                form_url: '',
                campaign_type: '',
                categories: [],
                application_condition_1: {},
                application_condition_2: {},
                sale_staff: [],
                progress_status: [],
                person_in_charge: [],
                project_management: [],
                customer_team_pic: [],
                customer_sub_person: [],
                part_time_employee: [],
                order_scope_large: [],
                order_scope_department: [],
                order_scope_inquiry: [],
                order_scope_inquiry_detail: [],
                order_scope_application: [],
                order_scope_application_detail: [],
                order_scope_secretariat: [],
                order_scope_secretariat_detail: [],
                order_scope_sns_account: [],
                order_scope_sns_account_detail: [],
                order_scope_shipping: [],
                order_scope_shipping_detail: [],
                order_scope_production: [],
                order_scope_production_detail: [],
                scope_partner_inquiry: [],
                scope_partner_application: [],
                scope_partner_secretariat: [],
                scope_partner_shipping: [],
                tool: [],
                prize_type: [],
                prize_type_detail: [],
                purchase_conditions: [],
                responsible_sub_persons: [],
                direction_staff: [],
                is_before_due_date: [],
                is_post_effective_date: [],
                year_end_holiday: [],
                give_away_related: [],
                target_product_list_1: [],
                target_product_list_2: [],
                information_ip: [],
                information_ip_detail: [],
                sponsor_information: [],
                client_order_source_type: [],
                client_generate_file_type: [],
                advertising_activity_id: [],
                social_platform_id: [],
                created_by: ''
            };
            this.clientObject = null;
            this.clientPicObject = null;
            this.has = configHelperCampaign.getHas();
            this.created_by = [];
            this.highSearchs.zac_id = [];
            this.highSearchs.campaign_entity_id = [];
            this.configKeywordCampaignEntityId.arrayTag = [];
            this.highSearchs.sfid = [];
            this.highSearchs.offical_name_sns = {};
            this.highSearchs.offical_id_sns = {};
            this.highSearchs.form_url = [];
            this.highSearchs.number_of_applications = {};
            this.highSearchs.initial_quantity = {};
            this.highSearchs.final_quantity = {};
            this.highSearchs.increase_quantity = {};
            this.highSearchs.number_of_inquiries = {};
            this.highSearchs.social_platforms = {};
            this.activeAccordions = {
                overview: true,
                period: false,
                product: false,
                site: false,
                prize: false,
                inquiry: false,
                other: false,
                scope: false,
                customer: false,
                staff: false,
                advertising: false
            };
            this.highSearchs.inform = [];
            this.highSearchs.url = [];
            this.highSearchs.information_ip_detail = [];
            this.highSearchs.tie_up_distribution_name = [];
            this.highSearchs.tie_up_manufacturer_name = [];
            this.highSearchs.contact_information_dm = [];
            this.highSearchs.keywords = [];
            this.highSearchs.memo = [];
            this.highSearchs.prize_search = [];
            this.highSearchs.form_url = [];
            this.highSearchs.number_of_applications = {};
            this.date_from = {
                total_win_from: '',
                total_inquiry_from: '',
                quantity_for_event_prize: '',
                number_of_win_prize: '',
                total_application_from: '',
                campaign_end_date: '',
                campaign_end_date_y: '',
                campaign_end_date_m: '',
                campaign_end_date_d: '',

                campaign_start_date: '',
                campaign_start_date_y: '',
                campaign_start_date_m: '',
                campaign_start_date_d: '',

                secretariat_end_date: '',
                secretariat_end_date_y: '',
                secretariat_end_date_m: '',
                secretariat_end_date_d: '',

                receipt_expiration_start_date: '',
                receipt_expiration_start_date_y: '',
                receipt_expiration_start_date_m: '',
                receipt_expiration_start_date_d: '',

                receipt_expiration_end_date: '',
                receipt_expiration_end_date_y: '',
                receipt_expiration_end_date_m: '',
                receipt_expiration_end_date_d: '',

                url_publish_time_from: '',
                url_publish_time_from_y: '',
                url_publish_time_from_m: '',
                url_publish_time_from_d: '',

                url_publish_time_to: '',
                url_publish_time_to_y: '',
                url_publish_time_to_m: '',
                url_publish_time_to_d: '',

                prize_shipping_period: '',
                prize_shipping_period_y: '',
                prize_shipping_period_m: '',
                prize_shipping_period_d: '',
                campaign_create_date: '',
                campaign_create_date_y: '',
                campaign_create_date_m: '',
                campaign_create_date_d: '',
                campaign_start_date_time: '',
                campaign_start_date_time_y: '',
                campaign_start_date_time_m: '',
                campaign_start_date_time_d: '',
                campaign_start_date_time_full_time: '',
                campaign_end_date_time: '',
                campaign_end_date_time_y: '',
                campaign_end_date_time_m: '',
                campaign_end_date_time_d: '',
                campaign_end_date_time_full_time: '',
                secretariat_start_date_time: '',
                secretariat_start_date_time_y: '',
                secretariat_start_date_time_m: '',
                secretariat_start_date_time_d: '',
                secretariat_start_date_time_full_time: '',
                secretariat_end_date_time: '',
                secretariat_end_date_time_y: '',
                secretariat_end_date_time_m: '',
                secretariat_end_date_time_d: '',
                secretariat_end_date_time_full_time: ''
            };
            this.date_to = {
                total_win_to: '',
                total_inquiry_to: '',
                quantity_for_event_prize: '',
                number_of_win_prize: '',
                total_application_to: '',
                campaign_start_date: '',
                campaign_start_date_y: '',
                campaign_start_date_m: '',
                campaign_start_date_d: '',

                campaign_end_date: '',
                campaign_end_date_y: '',
                campaign_end_date_m: '',
                campaign_end_date_d: '',

                secretariat_end_date: '',
                secretariat_end_date_y: '',
                secretariat_end_date_m: '',
                secretariat_end_date_d: '',

                receipt_expiration_start_date: '',
                receipt_expiration_start_date_y: '',
                receipt_expiration_start_date_m: '',
                receipt_expiration_start_date_d: '',

                receipt_expiration_end_date: '',
                receipt_expiration_end_date_y: '',
                receipt_expiration_end_date_m: '',
                receipt_expiration_end_date_d: '',

                url_publish_time_from: '',
                url_publish_time_from_y: '',
                url_publish_time_from_m: '',
                url_publish_time_from_d: '',

                url_publish_time_to: '',
                url_publish_time_to_y: '',
                url_publish_time_to_m: '',
                url_publish_time_to_d: '',

                prize_shipping_period: '',
                prize_shipping_period_y: '',
                prize_shipping_period_m: '',
                prize_shipping_period_d: '',
                campaign_create_date: '',
                campaign_create_date_y: '',
                campaign_create_date_m: '',
                campaign_create_date_d: '',
                campaign_start_date_time: '',
                campaign_start_date_time_y: '',
                campaign_start_date_time_m: '',
                campaign_start_date_time_d: '',
                campaign_start_date_time_full_time: '',
                campaign_end_date_time: '',
                campaign_end_date_time_y: '',
                campaign_end_date_time_m: '',
                campaign_end_date_time_d: '',
                campaign_end_date_time_full_time: '',
                secretariat_start_date_time: '',
                secretariat_start_date_time_y: '',
                secretariat_start_date_time_m: '',
                secretariat_start_date_time_d: '',
                secretariat_start_date_time_full_time: '',
                secretariat_end_date_time: '',
                secretariat_end_date_time_y: '',
                secretariat_end_date_time_m: '',
                secretariat_end_date_time_d: '',
                secretariat_end_date_time_full_time: ''
            };
            this.sale_staff = null;
            this.project_management = [];
            this.customer_team_pic = [];
            this.customer_sub_person = [];
            this.part_time_employee = [];
            this.person_in_charge = [];
            this.responsible_sub_persons = [];
            this.direction_staff = [];
            this.scope_partner_inquiry = [];
            this.scope_partner_application = [];
            this.scope_partner_secretariat = [];
            this.scope_partner_shipping = [];
            this.tool = [];
            this.checkTodayCampaignStartDate = false;
            this.checkTodayCampaignEndDate = false;
            this.checkTodaySecretariatStartDate = false;
            this.checkTodaySecretariatEndDate = false;
            localStorage.removeItem('BookmarkCampaign');
            this.getList();
        },

        formatDateCommon(date, type) {
            return formatDateCommon(date, type);
        },

        renderStatus(status) {
            let index = campaignStatus.findIndex((x) => {
                return x.id == status;
            });
            if (index >= 0) {
                return campaignStatus[index];
            }
        },
        renderNameClientFile(clientGenerateFile) {
            if (!clientGenerateFile) return '';
            return clientGenerateFile?.name ?? '';
        },
        addBookMarkLocalStorage() {
            let query = {
                checkShowFilter: this.checkShowFilter,
                filterType: this.filterType,
                configKeyword: this.configKeyword,
                configKeywordOffice: this.configKeywordOffice,
                configKeywordPhoneInformation: this.configKeywordPhoneInformation,
                configKeywordMailInformation: this.configKeywordMailInformation,
                configKeywordInform: this.configKeywordInform,
                configKeywordInformationIpDetail: this.configKeywordInformationIpDetail,
                configKeywordOverviewInformation: this.configKeywordOverviewInformation,
                configKeywordTieUpDistributionName: this.configKeywordTieUpDistributionName,
                configKeywordTieUpManufacturerName: this.configKeywordTieUpManufacturerName,
                configKeywordContactInformationDm: this.configKeywordContactInformationDm,
                configKeywordKeywords: this.configKeywordKeywords,
                configKeywordMemo: this.configKeywordMemo,
                configKeywordHashtag: this.configKeywordHashtag,
                configKeywordApplicationMethod: this.configKeywordApplicationMethod,
                configKeywordCode: this.configKeywordCode,
                configKeywordName: this.configKeywordName,
                configKeywordOrderSource: this.configKeywordOrderSource,
                configKeywordGenerateFile: this.configKeywordGenerateFile,
                configKeywordZacId: this.configKeywordZacId,
                configKeywordCampaignEntityId: this.configKeywordCampaignEntityId,
                configKeywordSfid: this.configKeywordSfid,
                configKeywordFormUrl: this.configKeywordFormUrl,
                configKeywordUrl: this.configKeywordUrl,
                configKeywordPrizeSearch: this.configKeywordPrizeSearch,
                configKeywordOfficalNameSns: this.configKeywordOfficalNameSns,
                configKeywordOfficalIdSns: this.configKeywordOfficalIdSns,
                search: this.search,
                filter: this.filter,
                has: this.has,
                date_to: this.date_to,
                date_from: this.date_from,
                highSearchs: this.highSearchs,
                checkTodayCampaignStartDate: this.checkTodayCampaignStartDate,
                checkTodaySecretariatStartDate: this.checkTodaySecretariatStartDate,
                checkTodaySecretariatEndDate: this.checkTodaySecretariatEndDate,
                activeAccordions: this.activeAccordions,
                configPage: this.configPage
            };
            localStorage.setItem('BookmarkCampaign', JSON.stringify(query));
        },
        addBookMark() {
            let query = {
                checkShowFilter: this.checkShowFilter,
                filterType: this.filterType,
                configKeyword: this.configKeyword,
                configKeywordOffice: this.configKeywordOffice,
                configKeywordPhoneInformation: this.configKeywordPhoneInformation,
                configKeywordMailInformation: this.configKeywordMailInformation,
                search: this.search,
                filter: this.filter,
                has: this.has,
                date_to: this.date_to,
                date_from: this.date_from,
                highSearchs: this.highSearchs,
                configKeywordCode: this.configKeywordCode,
                configKeywordName: this.configKeywordName,
                configKeywordOrderSource: this.configKeywordOrderSource,
                configKeywordGenerateFile: this.configKeywordGenerateFile,
                configKeywordZacId: this.configKeywordZacId,
                configKeywordCampaignEntityId: this.configKeywordCampaignEntityId,
                configKeywordSfid: this.configKeywordSfid,
                configKeywordFormUrl: this.configKeywordFormUrl,
                configKeywordUrl: this.configKeywordUrl,
                configKeywordPrizeSearch: this.configKeywordPrizeSearch,
                configKeywordOfficalNameSns: this.configKeywordOfficalNameSns,
                configKeywordOfficalIdSns: this.configKeywordOfficalIdSns
            };
            let objectData = {
                name: this.bookmarkName,
                page: 'campaign',
                query: {
                    data: JSON.stringify(query)
                }
            };
            this.addBookmark(objectData).then((data) => {
                if (data.code == 200) this.getListBookmark();
            });
        },

        renderLargeItemPartnerUnique(largeItemPartner) {
            if (largeItemPartner.mos_partner_secretariat_related_names && largeItemPartner.mos_partner_shipping_names)
                return largeItemPartner.mos_partner_secretariat_related_names.concat('・', largeItemPartner.mos_partner_shipping_names);
            if (largeItemPartner.mos_partner_secretariat_related_names && !largeItemPartner.mos_partner_shipping_names)
                return largeItemPartner.mos_partner_secretariat_related_names;
            if (!largeItemPartner.mos_partner_secretariat_related_names && largeItemPartner.mos_partner_shipping_names)
                return largeItemPartner.mos_partner_shipping_names;
        },

        onResizeTable(e, subHeader) {
            if (!e.target.classList.contains('resize-handle')) return;
            const getIndex = this.configTable.headers
                .map((item) => item.sub_headers)
                .flat()
                .findIndex((subItem) => subItem.label === subHeader.label);
            this.resizing = true;
            this.currentColumnIndex = getIndex;
            this.startX = e.pageX;
            this.startWidth = subHeader.width;
            document.addEventListener('mousemove', this.onResize);
            document.addEventListener('mouseup', this.stopResize);
        },
        onResize(e) {
            if (!this.resizing) return;
            const dx = e.pageX - this.startX;
            const newWidth = Math.max(60, this.startWidth + dx);
            this.configTable.headers.map((item) => item.sub_headers).flat()[this.currentColumnIndex].width = newWidth;
            this.recalculateHeaderWidths();
        },
        stopResize() {
            this.resizing = false;
            if (this.configTable?.nameTable) localStorage.setItem(this.configTable.nameTable, JSON.stringify(this.configTable.headers));
            document.removeEventListener('mousemove', this.onResize);
            document.removeEventListener('mouseup', this.stopResize);
        },
        recalculateHeaderWidths() {
            this.configTable.headers.forEach((header) => {
                if (header.sub_headers?.length) {
                    header.width = header.sub_headers.reduce((t, s) => t + (s.width || 0), 0);
                }
            });
        },
        getWidthTableStorage() {
            if (this.configTable?.nameTable) {
                let data = localStorage.getItem(this.configTable.nameTable);
                if (data) {
                    this.configTable.headers = JSON.parse(data);
                }
            }
        },

        onHandleOpenDownload() {
            this.MODAL_CONFIG.model = true;
        },
        handleGlobalEnter(e) {
            if (e.key === 'Enter') {
                const activeElement = document.activeElement;
                if (
                    activeElement.tagName === 'INPUT' ||
                    activeElement.tagName === 'TEXTAREA' ||
                    activeElement.tagName === 'SELECT' ||
                    activeElement.isContentEditable ||
                    activeElement.closest('.b-form-tags')
                ) {
                    return;
                }
                this.handleSearch();
            }
        }
    }
};
</script>

<template>
    <Layout>
        <div class="row">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-header d-flex" style="gap: 0.5rem">
                        <h3 class="mb-0 title--screen">キャンペーン検索</h3>
                        <div class="ml-auto">
                            <ButtonActiveFilter :active.sync="isActiveFilter" :smallCol="672" :largeCol="50" />
                        </div>
                    </div>
                    <div v-if="isActiveFilter" class="card-body position-relative">
                        <div class="row justify-content-center">
                            <div class="col-sm-9 position-static">
                                <div class="form-group row">
                                    <label class="col-sm-3" for="validationCustom05">検索種別</label>
                                    <div class="col-sm-9 d-flex align-items-center">
                                        <InputRadio class="mr-4" :model.sync="filterType" :id="`filterType-basic`" value="basic" label="簡単検索" />
                                        <InputRadio
                                            class="mr-4"
                                            :model.sync="filterType"
                                            :id="`filterType-advanced`"
                                            value="advanced"
                                            label="複雑検索"
                                        />
                                    </div>
                                </div>
                                <form class="needs-validation" autocomplete="off" @submit.prevent="handleSearch()">
                                    <div v-if="!checkShowFilter" class="row form-group">
                                        <div class="col-sm-12">
                                            <KeyWordTag :config="configKeyword" class="" />
                                        </div>
                                    </div>

                                    <div v-if="checkShowFilter">
                                        <CampaignFilterBasic
                                            v-if="filterType === 'basic'"
                                            :filter.sync="filter"
                                            :search.sync="search"
                                            :campaignStatus="campaignStatus"
                                            :listDataMasterCampaignType="listDataMasterCampaignType"
                                            :date_from.sync="date_from"
                                            :date_to.sync="date_to"
                                            :checkTodayCampaignStartDate="checkTodayCampaignStartDate"
                                            :checkTodayCampaignEndDate="checkTodayCampaignEndDate"
                                            :checkTodaySecretariatStartDate="checkTodaySecretariatStartDate"
                                            :checkTodaySecretariatEndDate="checkTodaySecretariatEndDate"
                                            :listDataMasterSaleStaf="listDataMasterSaleStaf"
                                            :listDataMasterInstructorStaf="listDataMasterInstructorStaf"
                                            :sale_staff.sync="sale_staff"
                                            :person_in_charge.sync="person_in_charge"
                                            :responsible_sub_persons.sync="responsible_sub_persons"
                                            :direction_staff.sync="direction_staff"
                                            :listTypeTitlePrize="listTypeTitlePrize"
                                            :configTotalWin="configTotalWin"
                                            :configKeywordOffice="configKeywordOffice"
                                            :configKeywordPhoneInformation="configKeywordPhoneInformation"
                                            :configKeywordMailInformation="configKeywordMailInformation"
                                            :listDataMasterOrderScope="listDataMasterOrderScope"
                                            :listFilterScopeDepartment="listFilterScopeDepartment"
                                            :listFilterScopeInquiry="listFilterScopeInquiry"
                                            :listAllPartnersInquiry="listAllPartnersInquiry"
                                            :listAllPartnersApplication="listAllPartnersApplication"
                                            :listAllPartnersSecretariat="listAllPartnersSecretariat"
                                            :listAllPartnersShipping="listAllPartnersShipping"
                                            :listAllTools="listAllTools"
                                            :scope_partner_inquiry.sync="scope_partner_inquiry"
                                            :scope_partner_application.sync="scope_partner_application"
                                            :scope_partner_secretariat.sync="scope_partner_secretariat"
                                            :scope_partner_shipping.sync="scope_partner_shipping"
                                            :tool.sync="tool"
                                            :configKeywordCode="configKeywordCode"
                                            :configKeywordName="configKeywordName"
                                            :configKeywordOrderSource="configKeywordOrderSource"
                                            :configKeywordGenerateFile="configKeywordGenerateFile"
                                            @changeFilterInquiry="handleChangeFilterInquiry"
                                            @changeCheckToday="onCheckToday"
                                        />
                                        <CampaignFilterAdvanced
                                            v-if="filterType === 'advanced'"
                                            :filter.sync="filter"
                                            :search.sync="search"
                                            :campaignStatus="campaignStatus"
                                            :listDataMasterCampaignType="listDataMasterCampaignType"
                                            :listDataMasterCampaignAdvertising="listDataMasterCampaignAdvertising"
                                            :date_from.sync="date_from"
                                            :date_to.sync="date_to"
                                            :checkTodayCampaignStartDate="checkTodayCampaignStartDate"
                                            :checkTodaySecretariatStartDate="checkTodaySecretariatStartDate"
                                            :checkTodaySecretariatEndDate="checkTodaySecretariatEndDate"
                                            :checkTodayCampaignEndDate="checkTodayCampaignEndDate"
                                            :listDataMasterSaleStaf="listDataMasterSaleStaf"
                                            :listDataMasterInstructorStaf="listDataMasterInstructorStaf"
                                            :listDataCustomerTeamPic="listDataCustomerTeamPic"
                                            :listDataMasterParttime="listDataMasterParttime"
                                            :sale_staff.sync="sale_staff"
                                            :person_in_charge.sync="person_in_charge"
                                            :responsible_sub_persons.sync="responsible_sub_persons"
                                            :direction_staff.sync="direction_staff"
                                            :listTypeTitlePrize="listTypeTitlePrize"
                                            :listPurchaseConditions="listPurchaseConditions"
                                            :listTargetProduct="listTargetProduct"
                                            :listInformationIp="listInformationIp"
                                            :listSponsorInformation="listSponsorInformation"
                                            :listSocialPlatform="listSocialPlatform"
                                            :configTotalWin="configTotalWin"
                                            :configTotalInquiry="configTotalInquiry"
                                            :configKeywordOffice="configKeywordOffice"
                                            :configKeywordPhoneInformation="configKeywordPhoneInformation"
                                            :configKeywordMailInformation="configKeywordMailInformation"
                                            :listDataMasterOrderScope="listDataMasterOrderScope"
                                            :listFilterScopeDepartment="listFilterScopeDepartment"
                                            :listFilterScopeInquiry="listFilterScopeInquiry"
                                            :listAllPartnersInquiry="listAllPartnersInquiry"
                                            :listAllPartnersApplication="listAllPartnersApplication"
                                            :listAllPartnersSecretariat="listAllPartnersSecretariat"
                                            :listAllPartnersShipping="listAllPartnersShipping"
                                            :listAllTools="listAllTools"
                                            :scope_partner_inquiry.sync="scope_partner_inquiry"
                                            :scope_partner_application.sync="scope_partner_application"
                                            :scope_partner_secretariat.sync="scope_partner_secretariat"
                                            :scope_partner_shipping.sync="scope_partner_shipping"
                                            :tool.sync="tool"
                                            :listFilterScopeApplication="listFilterScopeApplication"
                                            :listFilterScopeSecretariat="listFilterScopeSecretariat"
                                            :listFilterScopeShipping="listFilterScopeShipping"
                                            :listFilterScopeProduction="listFilterScopeProduction"
                                            :listFilterScopeSns="listFilterScopeSns"
                                            :created_by.sync="created_by"
                                            :zac_id.sync="highSearchs.zac_id"
                                            :sfid.sync="highSearchs.sfid"
                                            :url.sync="highSearchs.url"
                                            :offical_name_sns.sync="highSearchs.offical_name_sns"
                                            :offical_id_sns.sync="highSearchs.offical_id_sns"
                                            :configKeywordHashtag="configKeywordHashtag"
                                            :configKeywordApplicationMethod="configKeywordApplicationMethod"
                                            :configKeywordInform="configKeywordInform"
                                            :configKeywordOverviewInformation="configKeywordOverviewInformation"
                                            :configKeywordInformationIpDetail="configKeywordInformationIpDetail"
                                            :configKeywordTieUpDistributionName="configKeywordTieUpDistributionName"
                                            :configKeywordTieUpManufacturerName="configKeywordTieUpManufacturerName"
                                            :configKeywordContactInformationDm="configKeywordContactInformationDm"
                                            :configKeywordKeywords="configKeywordKeywords"
                                            :configKeywordMemo="configKeywordMemo"
                                            :listProjectManagement="listProjectManagement"
                                            :listEmployee="listEmployee"
                                            :project_management.sync="project_management"
                                            :customer_team_pic.sync="customer_team_pic"
                                            :customer_sub_person.sync="customer_sub_person"
                                            :part_time_employee.sync="part_time_employee"
                                            :prize_search.sync="highSearchs.prize_search"
                                            :form_url.sync="highSearchs.form_url"
                                            :number_of_applications.sync="highSearchs.number_of_applications"
                                            :initial_quantity.sync="highSearchs.initial_quantity"
                                            :final_quantity.sync="highSearchs.final_quantity"
                                            :increase_quantity.sync="highSearchs.increase_quantity"
                                            :number_of_inquiries.sync="highSearchs.number_of_inquiries"
                                            :social_platforms.sync="highSearchs.social_platforms"
                                            :configKeywordCode="configKeywordCode"
                                            :configKeywordName="configKeywordName"
                                            :configKeywordOrderSource="configKeywordOrderSource"
                                            :configKeywordGenerateFile="configKeywordGenerateFile"
                                            :configKeywordZacId="configKeywordZacId"
                                            :configKeywordCampaignEntityId="configKeywordCampaignEntityId"
                                            :configKeywordSfid="configKeywordSfid"
                                            :configKeywordFormUrl="configKeywordFormUrl"
                                            :configKeywordUrl="configKeywordUrl"
                                            :configKeywordPrizeSearch="configKeywordPrizeSearch"
                                            :configKeywordOfficalNameSns="configKeywordOfficalNameSns"
                                            :configKeywordOfficalIdSns="configKeywordOfficalIdSns"
                                            :activeAccordions.sync="activeAccordions"
                                            @changeFilterApplication="handleChangeFilterApplication"
                                            @changeFilterSecretariat="handleChangeFilterSecretariat"
                                            @changeFilterSecretariatDetail="handleChangeFilterSecretariatDetail"
                                            @changeFilterShipping="handleChangeFilterShipping"
                                            @changeFilterProduction="handleChangeFilterProduction"
                                            @changeFilterSns="handleChangeFilterSns"
                                            @changeFilterInquiry="handleChangeFilterInquiry"
                                            @changeCheckToday="onCheckToday"
                                        />
                                    </div>
                                    <hr />
                                    <div class="text-center mt-2">
                                        <button type="button" @click="clear()" class="btn btn-common btn-outline-primary">
                                            <i class="ri-restart-line"></i>クリア
                                        </button>
                                        <button type="submit" class="btn btn-common btn-primary ml-3"><i class="ri-search-line"></i>検索</button>
                                        <button type="button" @click="handleShowFilter" class="btn btn-common filter btn-outline-primary">
                                            <i class="ri-equalizer-line"></i>絞り込み条件を表示
                                        </button>
                                    </div>
                                </form>
                                <div class="form-group row mt-3">
                                    <label class="" style="min-width: fit-content" for="validationCustom05">Bookmark</label>
                                    <div class="col-sm-9">
                                        <button
                                            type="button"
                                            v-for="(item, k) in listDataBookmark"
                                            @click="setBookmark(item.query.data)"
                                            :key="k"
                                            class="btn btn-outline-info mr-2 mb-2"
                                            style="position: relative"
                                        >
                                            {{ item.name }}
                                            <i
                                                @click="deleteBookmarks($event, item)"
                                                style="position: absolute; top: -2px; right: -2px"
                                                class="fa fa-window-close"
                                            ></i>
                                        </button>
                                    </div>
                                </div>
                                <div class="row">
                                    <label class="col-sm-2" for="validationCustom05">Today検索</label>
                                    <div class="col-sm-9">
                                        <div class="d-flex flex-wrap">
                                            <InputCheckBox
                                                class="mr-3 mb-2"
                                                :model.sync="checkTodayCampaignStartDate"
                                                :value="checkTodayCampaignStartDate"
                                                :id="`check-checkTodayCampaignStartDate`"
                                                label="キャンペーン開始日"
                                                @change="onCheckToday(checkTodayCampaignStartDate, 'campaign_start_date')"
                                            />
                                            <InputCheckBox
                                                class="mr-3 mb-2"
                                                :model.sync="checkTodayCampaignEndDate"
                                                :value="checkTodayCampaignEndDate"
                                                :id="`check-checkTodayCampaignEndDate`"
                                                label="キャンペーン終了日"
                                                @change="onCheckToday(checkTodayCampaignEndDate, 'campaign_end_date')"
                                            />
                                            <InputCheckBox
                                                class="mr-3 mb-2"
                                                :model.sync="checkTodaySecretariatStartDate"
                                                :value="checkTodaySecretariatStartDate"
                                                :id="`check-checkTodaySecretariatStartDate`"
                                                label="事務局開始日"
                                                @change="onCheckToday(checkTodaySecretariatStartDate, 'secretariat_start_date')"
                                            />
                                            <InputCheckBox
                                                class="mr-3 mb-2"
                                                :model.sync="checkTodaySecretariatEndDate"
                                                :value="checkTodaySecretariatEndDate"
                                                :id="`check-checkTodaySecretariatEndDate`"
                                                label="事務局終了日"
                                                @change="onCheckToday(checkTodaySecretariatEndDate, 'secretariat_end_date')"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="card mb-0" ref="searchResult">
                    <div class="card-header">
                        <h3 class="mb-0 title--screen">
                            キャンペーン検索結果 <span>件数（{{ configPage.total }})</span>
                        </h3>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-12 mb-3">
                                <div class="d-flex align-items-center input-group-sm" style="white-space: nowrap">
                                    検索条件：
                                    <input type="text" class="form-control ml-3" v-model="bookmarkName" style="width: 200px" />
                                    <button class="btn btn-sm btn-primary ml-2" @click="addBookMark()">保存</button>
                                    <div class="ml-auto">
                                        <button
                                            v-if="checkPermission('campaign.download')"
                                            class="btn btn-sm btn-info px-3"
                                            @click="onHandleOpenDownload"
                                        >
                                            {{ $t('pageCampaign.dataDownload') }}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <TableListComponent
                            :heightTable="tableHeight"
                            :dataList="listData"
                            :isLoading="isLoading"
                            :configPage.sync="configPage"
                            :stickyAction="true"
                            @onChangePage="getList()"
                        >
                            <template #colgroup>
                                <col
                                    v-for="(item, kCol) in configTable.headers.flatMap((h) => h.sub_headers)"
                                    :key="kCol"
                                    :style="{ width: item.width + 'px' }"
                                />
                            </template>
                            <template #head>
                                <tr>
                                    <th
                                        v-for="(item, k) in configTable.headers"
                                        :key="k"
                                        class="text-left position-sticky"
                                        :rowspan="item.rowSpan ?? 1"
                                        :colspan="item.sub_headers?.length ?? 1"
                                        :style="{
                                            width: item.width + 'px',
                                            backgroundColor: item?.backgroundColor,
                                            top: 0,
                                            left: k === 0 ? 0 : 'auto',
                                            zIndex: k === 0 ? 70 : 65
                                        }"
                                    >
                                        <div class="el-table__cell">
                                            {{ item.label }}
                                        </div>
                                    </th>
                                    <th
                                        :style="{ width: configTable?.widthAction + 'px', top: 0, zIndex: 65 }"
                                        :class="`text-center sticky_action`"
                                    ></th>
                                </tr>
                                <tr>
                                    <template v-for="(item, k) in configTable.headers">
                                        <th
                                            v-for="(subItem, ubs) in item.sub_headers"
                                            :key="`${k}-sub-${ubs}`"
                                            class="text-left position-sticky"
                                            :style="{
                                                width: subItem.width + 'px',
                                                backgroundColor: subItem?.backgroundColor,
                                                top: '44px',
                                                left: k === 0 ? (ubs === 0 ? 0 : codeColWidth) : 'auto',
                                                zIndex: k === 0 ? 70 : 60
                                            }"
                                            @mousedown="onResizeTable($event, subItem)"
                                        >
                                            <div class="el-table__cell">
                                                {{ subItem.label }}
                                            </div>
                                            <span class="resize-handle"></span>
                                        </th>
                                    </template>
                                    <th
                                        :style="{ width: configTable?.widthAction + 'px', top: '44px', zIndex: 60 }"
                                        :class="`text-center sticky_action`"
                                    ></th>
                                </tr>
                            </template>
                            <template #row="{ row }">
                                <tr>
                                    <td class="text-left position-sticky sticky-col-bg" :style="{ left: 0, zIndex: 50 }">{{ row?.code }}</td>
                                    <td class="text-left position-sticky sticky-col-bg" :style="{ left: codeColWidth, zIndex: 50 }">
                                        <InlineEditWrapper
                                            :is-editing="isEditingInline(row.id, 'name', inlineEdit)"
                                            :show-edit-icon="checkPermission('campaign.edit')"
                                            :tooltip="row.name"
                                            @start="onHandleStartInlineEdit(row, 'name')"
                                            @save="onHandleSaveCampaignInline(row, 'name')"
                                            @cancel="onHandleCancelInlineEdit()"
                                        >
                                            <template #input>
                                                <InputText
                                                    :style="{ width: '100%' }"
                                                    :model.sync="inlineEdit.value"
                                                    :config.sync="inlineEdit.config"
                                                    @blur="handleValidateFieldInline(inlineEdit.value, inlineEdit.config)"
                                                />
                                            </template>
                                            <template #display>
                                                <span class="text-truncate">{{ row.name }}</span>
                                            </template>
                                        </InlineEditWrapper>
                                    </td>
                                    <td class="text-left">
                                        <InlineEditWrapper
                                            :is-editing="isEditingInline(row.id, 'sale_staff_id', inlineEdit)"
                                            :show-edit-icon="checkPermission('campaign.edit')"
                                            @start="onHandleStartInlineEdit(row, 'sale_staff_id')"
                                            @save="onHandleSaveCampaignInline(row, 'sale_staff_id')"
                                            @cancel="onHandleCancelInlineEdit()"
                                        >
                                            <template #input>
                                                <Multiselect
                                                    :id="`select-sale-staff-inline-${row.id}`"
                                                    :value.sync="inlineEdit.value"
                                                    :options="listSaleStaff"
                                                    :config.sync="inlineEdit.config"
                                                />
                                            </template>
                                            <template #display>
                                                <span class="text-truncate">{{ row.sale_staff ? row.sale_staff.name : '' }}</span>
                                            </template>
                                        </InlineEditWrapper>
                                    </td>
                                    <td class="text-left">
                                        <InlineEditWrapper
                                            :is-editing="isEditingInline(row.id, 'person_in_charge_id', inlineEdit)"
                                            :show-edit-icon="checkPermission('campaign.edit')"
                                            @start="onHandleStartInlineEdit(row, 'person_in_charge_id')"
                                            @save="onHandleSaveCampaignInline(row, 'person_in_charge_id')"
                                            @cancel="onHandleCancelInlineEdit()"
                                        >
                                            <template #input>
                                                <Multiselect
                                                    :id="`select-person-inline-${row.id}`"
                                                    :value.sync="inlineEdit.value"
                                                    :options="listPIC"
                                                    :config.sync="inlineEdit.config"
                                                />
                                            </template>
                                            <template #display>
                                                <span class="text-truncate">{{ row.person_in_charge ? row.person_in_charge.name : '' }}</span>
                                            </template>
                                        </InlineEditWrapper>
                                    </td>
                                    <td class="text-left">
                                        <div class="el-table__cell">
                                            {{ row.responsible_sub_persons?.find((item) => item.sub_person_position === 1)?.name ?? '' }}
                                        </div>
                                    </td>
                                    <td class="text-left">
                                        <div class="el-table__cell">
                                            {{ formatDateCommon(row.campaign_start_date, 'dateTimeJP') }}
                                        </div>
                                    </td>
                                    <td class="text-left">
                                        <div class="el-table__cell">
                                            {{ formatDateCommon(row.campaign_end_date, 'dateTimeJP') }}
                                        </div>
                                    </td>
                                    <td class="text-left">
                                        <div class="el-table__cell">
                                            {{ formatDateCommon(row.secretariat_start_date, 'dateTimeJP') }}
                                        </div>
                                    </td>
                                    <td class="text-left">
                                        <div class="el-table__cell">
                                            {{ formatDateCommon(row.secretariat_end_date, 'dateTimeJP') }}
                                        </div>
                                    </td>
                                    <td class="text-left" :style="`background-color:${renderStatus(row.progress_status)?.backgroundColor}`">
                                        <InlineEditWrapper
                                            :is-editing="isEditingInline(row.id, 'progress_status', inlineEdit)"
                                            :show-edit-icon="checkPermission('campaign.edit')"
                                            @start="onHandleStartInlineEdit(row, 'progress_status')"
                                            @save="onHandleSaveCampaignInline(row, 'progress_status')"
                                            @cancel="onHandleCancelInlineEdit()"
                                        >
                                            <template #input>
                                                <Multiselect
                                                    :id="`select-status-inline-${row.id}`"
                                                    :value.sync="inlineEdit.value"
                                                    :options="campaignStatus"
                                                    :config.sync="inlineEdit.config"
                                                />
                                            </template>
                                            <template #display>
                                                {{ renderStatus(row.progress_status)?.text }}
                                            </template>
                                        </InlineEditWrapper>
                                    </td>
                                    <td class="text-left">
                                        <div class="el-table__cell">{{ row.campaign_type ? row.campaign_type.value : '' }}</div>
                                    </td>
                                    <td class="text-left">
                                        <div class="el-table__cell">{{ row.categories?.map((item) => item.value).join('・') ?? '' }}</div>
                                    </td>

                                    <td class="text-left">
                                        <div class="el-table__cell" v-b-tooltip.hover :title="renderNameClientFile(row.client_generate_file)">
                                            {{ renderNameClientFile(row.client_generate_file) }}
                                        </div>
                                    </td>

                                    <td class="text-left">
                                        <div class="el-table__cell">
                                            {{ row.client_order_source ? row.client_order_source.name : '' }}
                                        </div>
                                    </td>
                                    <td class="text-left">
                                        <div class="el-table__cell">
                                            {{
                                                row.event_prizes?.length > 0
                                                    ? row.event_prizes.reduce((sum, item) => sum + item.number_of_win_prize, 0)
                                                    : ''
                                            }}
                                        </div>
                                    </td>
                                    <td class="text-left">
                                        <div class="el-table__cell">
                                            <a :href="row.url" target="_blank"> {{ row.url ?? '' }} </a>
                                        </div>
                                    </td>
                                    <td class="text-left">
                                        <div class="el-table__cell">
                                            {{ row.phone_setting_contact_information ? row.phone_setting_contact_information : '' }}
                                        </div>
                                    </td>
                                    <td class="text-left">
                                        <div class="el-table__cell">
                                            {{
                                                row.contact_informations?.length > 0
                                                    ? row.contact_informations.find((item) => item.type.id === 5)?.extension?.content
                                                    : ''
                                            }}
                                        </div>
                                    </td>
                                    <td class="text-left">
                                        <div class="el-table__cell">{{ row.mos_partner_inquiries }}</div>
                                    </td>
                                    <td class="text-left">
                                        <InlineEditWrapper
                                            :is-editing="isEditingInline(row.id, 'inquiries', inlineEdit)"
                                            :show-edit-icon="checkPermission('campaign.edit')"
                                            type="textarea"
                                            @start="onHandleStartInlineEdit(row, 'inquiries')"
                                            @save="onHandleSaveCampaignInline(row, 'inquiries')"
                                            @cancel="onHandleCancelInlineEdit()"
                                        >
                                            <template #input>
                                                <TextareaComponent :model.sync="inlineEdit.value" :rows="`5`"></TextareaComponent>
                                            </template>
                                            <template #display>
                                                <span class="text-multi-truncate">{{ row?.campaign_content_other?.inquiries ?? '' }}</span>
                                            </template>
                                        </InlineEditWrapper>
                                    </td>
                                    <td class="text-left">
                                        <div class="el-table__cell">{{ row.customer_team_pic ? row.customer_team_pic.name : '' }}</div>
                                    </td>
                                    <td class="text-left">
                                        <div class="el-table__cell">
                                            {{ row.customer_sub_person?.length > 0 ? row.customer_sub_person[0].name : '' }}
                                        </div>
                                    </td>
                                    <td class="text-left">
                                        <div class="el-table__cell">
                                            {{
                                                row.campaign_master_order_scopes?.length > 0
                                                    ? row.campaign_master_order_scopes.map((item) => item.large_item.value).join('・')
                                                    : ''
                                            }}
                                        </div>
                                    </td>
                                    <td class="text-left">
                                        <div class="el-table__cell">{{ renderLargeItemPartnerUnique(row) }}</div>
                                    </td>
                                    <td class="text-left">
                                        <div class="el-table__cell">
                                            {{
                                                row.campaign_master_order_scope_partner?.length > 0
                                                    ? row.campaign_master_order_scope_partner
                                                          .map((item) => {
                                                              if (item.tool) return item.tool.tool;
                                                          })
                                                          .filter((item, index, self) => item && self.indexOf(item) === index)
                                                          .join('・')
                                                    : ''
                                            }}
                                        </div>
                                    </td>
                                    <td :align="checkPermission('campaign.edit') ? 'left' : 'center'" class="sticky_action" style="z-index: 55">
                                        <div class="row-data-small">
                                            <a
                                                href="javascript:void(0)"
                                                class="btn btn-common-sml btn-info mr-2"
                                                @click="goToEdit('/campaign/form/view', row)"
                                                ><i class="ri-file-list-2-line"></i>{{ $t('btn.detail') }}</a
                                            >
                                            <a
                                                v-if="row.is_approved != 0 && row.is_locked != 1 && checkPermission('campaign.edit')"
                                                href="javascript:void(0)"
                                                class="btn btn-common-sml btn-primary mr-2"
                                                @click="goToEdit('/campaign/edit', row)"
                                                ><i class="ri-edit-box-line"></i>{{ $t('btn.edit') }}</a
                                            >
                                            <a
                                                v-if="row.is_approved != 0 && row.is_locked != 1 && checkPermission('document.export')"
                                                v-b-tooltip.hover="`${$t('pageCampaign.document')}`"
                                                href="javascript:void(0)"
                                                @click="goToEdit('/documents', row)"
                                                class="btn btn-only-icon-sml btn-outline-primary"
                                                ><i class="ri-file-list-2-line"></i
                                            ></a>
                                        </div>
                                    </td>
                                </tr>
                            </template>
                        </TableListComponent>
                    </div>
                </div>
            </div>
        </div>
        <DownloadDataCampaign :modalConfig="MODAL_CONFIG" />
    </Layout>
</template>

<style lang="scss" scoped>
.filter {
    bottom: 90px;
}
.sticky-col-bg {
    background-color: #ffffff;
}
tr:hover .sticky-col-bg {
    background-color: #f8f9fa;
}
</style>
